[
	[1,1,"Abdominal Wall (GIT)",0,0  ],
	[2,2,"Gastrcoschisis",1,0  ],
	[3,3,"Herniated viscera Bowel",2,0  ],
	[4,3,"Herniated viscera Liver",2,0  ],
	[5,3,"Herniated viscera Stomach",2,0  ],
	[6,3,"Herniated viscera Mesentery",2,0  ],
	[7,3,"Herniated viscera Heart",2,0  ],
	[8,2,"Onphalocelle (Exomphalos)",1,0  ],
	[9,3,"Bowel",8,0  ],
	[10,3,"Liver",8,0  ],
	[11,3,"Stomach",8,0  ],
	[12,3,"Mesentery",8,0  ],
	[13,3,"Bladder",8,0  ],
	[14,3,"Heart",8,0  ],
	[15,2,"Body Stalk anomaly",1,0  ],
	[16,2,"Bladder extrophy",1,0  ],
	[17,2,"Cloacal extrophy",1,0  ],
	[18,1,"Brain (CNS)",0,0  ],
	[19,2,"Anencephaly",18,0  ],
	[20,2,"Absent corpus callosum",18,0  ],
	[21,2,"Encephalocele",18,0  ],
	[22,3,"Occipital",21,0  ],
	[23,3,"Parietal",21,0  ],
	[24,3,"Frontal",21,0  ],
	[25,3,"ethomidal",21,0  ],
	[26,2,"Exencephaly",18,0  ],
	[27,2,"Holoprosencephaly",18,0  ],
	[28,3,"Alobar",27,0  ],
	[29,3,"Semilobar",27,0  ],
	[30,3,"Lobar",27,0  ],
	[31,2,"Iniencephaly",18,0  ],
	[32,2,"Ventriculomegaly/Hydrocephalus",18,0  ],
	[33,2,"Calcification",18,0  ],
	[34,2,"Dilated Cisterna Magna",18,0  ],
	[35,2,"Cysts",18,0  ],
	[36,3,"Arachnoid",35,0  ],
	[37,3,"Choroid Plexus Left",35,0  ],
	[38,3,"Choroid Plexus Right",35,0  ],
	[39,3,"Porencephalic",35,0  ],
	[40,3,"Posterior Fossa",35,0  ],
	[41,2,"Vermis Agenesis",18,0  ],
	[42,1,"Extermities (Skeleton)",0,0  ],
	[43,2,"Feet Abnormal",42,0  ],
	[44,3,"Absent",43,0  ],
	[45,3,"Adactyly",43,0  ],
	[46,3,"Brachydactyly",43,0  ],
	[47,3,"Clinodactyly",43,0  ],
	[48,3,"Cleft Foot/Toes",43,0  ],
	[49,3,"Oligodactyly",43,0  ],
	[50,3,"Overlapping Toes",43,0  ],
	[51,3,"Polydactyly",43,0  ],
	[52,3,"Rocker-bottom",43,0  ],
	[53,3,"Sandal gap",43,0  ],
	[54,3,"Talipes equinovarus (Clubfoot)",43,0  ],
	[55,2,"Humerus Abnormal",42,0  ],
	[56,3,"Short",55,0  ],
	[57,3,"Bowed",55,0  ],
	[58,3,"Fractured",55,0  ],
	[59,3,"Absent",55,0  ],
	[60,2,"Radius Abnormal",42,0  ],
	[61,3,"Short",60,0  ],
	[62,3,"Bowed",60,0  ],
	[63,3,"Fractured",60,0  ],
	[64,3,"Absent",60,0  ],
	[65,2,"Tibia Abnormal",42,0  ],
	[66,3,"Short",65,0  ],
	[67,3,"Bowed",65,0  ],
	[68,3,"Fractured",65,0  ],
	[69,3,"Absent",65,0  ],
	[70,2,"Joints Abnormal",42,0  ],
	[71,3,"Elbows fixed, flexed",70,0  ],
	[72,3,"Elbows fixed, extended",70,0  ],
	[73,3,"Elbows Abducted",70,0  ],
	[74,3,"Elbows Adducted",70,0  ],
	[75,3,"Wrists fixed, flexed",70,0  ],
	[76,3,"Wrists fixed, extended",70,0  ],
	[77,3,"Wrists Abducted",70,0  ],
	[78,3,"Wrists Adducted",70,0  ],
	[79,3,"Knees fixed, flexed",70,0  ],
	[80,3,"Knees fixed, extended",70,0  ],
	[81,3,"Knees Abducted",70,0  ],
	[82,3,"Knees Adducted",70,0  ],
	[83,3,"Ankles fixed, flexed",70,0  ],
	[84,3,"Ankles fixed, extended",70,0  ],
	[85,3,"Ankles Abducted",70,0  ],
	[86,3,"Ankles Adducted",70,0  ],
	[87,2,"Hand Abnormal",42,0  ],
	[88,3,"Absent",87,0  ],
	[89,3,"Adactyly",87,0  ],
	[90,3,"Archnodactyly",87,0  ],
	[91,3,"Brachydactyly",87,0  ],
	[92,3,"Clinodactyly",87,0  ],
	[93,3,"Cleft Hand/Finger",87,0  ],
	[94,3,"Olygodactyly",87,0  ],
	[95,3,"Overlapping fingers",87,0  ],
	[96,3,"Polydactyly",87,0  ],
	[97,3,"Syndactyly",87,0  ],
	[98,2,"Femur Abnormal",42,0  ],
	[99,3,"Short",98,0  ],
	[100,3,"Bowed",98,0  ],
	[101,3,"Fractured",98,0  ],
	[102,3,"Absent",98,0  ],
	[103,2,"Ulna Abnormal",42,0  ],
	[104,3,"Short",103,0  ],
	[105,3,"Bowed",103,0  ],
	[106,3,"Fractured",103,0  ],
	[107,3,"Absent",103,0  ],
	[108,2,"Fibula Abnormal",42,0  ],
	[109,3,"Short",108,0  ],
	[110,3,"Bowed",108,0  ],
	[111,3,"Fractured",108,0  ],
	[112,3,"Absent",108,0  ],
	[113,1,"Face & Neck",0,0  ],
	[114,2,"Cleft",113,0  ],
	[115,3,"Lip",114,0  ],
	[116,3,"Palate",114,0  ],
	[117,3,"Lip & Palate",114,0  ],
	[118,2,"Ears",113,0  ],
	[119,3,"Small",118,0  ],
	[120,3,"Low-lying",118,0  ],
	[121,2,"Eyes",113,0  ],
	[122,3,"Anophthalmia",121,0  ],
	[123,3,"Microphthalmia",121,0  ],
	[124,3,"Cyclops",121,0  ],
	[125,3,"Hypotelorism",121,0  ],
	[126,3,"Hypertelorism",121,0  ],
	[127,3,"Echodense lens",121,0  ],
	[128,2,"Flat Face",113,0  ],
	[129,2,"Macroglossia",113,0  ],
	[130,2,"Micrognathia",113,0  ],
	[131,2,"Nose",113,0  ],
	[132,3,"Absent",131,0  ],
	[133,3,"Hypoplastic",131,0  ],
	[134,3,"Proboscis",131,0  ],
	[135,3,"Singular nostril",131,0  ],
	[136,2,"Facial Tumour",113,0  ],
	[137,1,"Genitalia (GUT)",0,0  ],
	[138,2,"Hydrocoele",137,0  ],
	[139,2,"Hypospadia",137,0  ],
	[140,2,"Hydrometrocolpos",137,0  ],
	[141,1,"GIT (Digest)",0,0  ],
	[142,2,"Stomach",141,0  ],
	[143,3,"Not visible",142,0  ],
	[144,3,"Collapsed",142,0  ],
	[145,3,"Dilated",142,0  ],
	[146,3,"Duodenal artesia (Double Bubble)",142,0  ],
	[147,2,"Ascite",141,0  ],
	[148,3,"Mild",147,0  ],
	[149,3,"Moderate",147,0  ],
	[150,3,"Severe",147,0  ],
	[151,2,"Liver",141,0  ],
	[152,3,"Nodule",151,0  ],
	[153,3,"Hepatomegaly",151,0  ],
	[154,2,"Small Bowel",141,0  ],
	[155,3,"Small Bowel Obstruction",154,0  ],
	[156,2,"Spleen",141,0  ],
	[157,3,"Splenomegaly",156,0  ],
	[158,2,"Large Bowel",141,0  ],
	[159,3,"Large Bowel Obstruction",158,0  ],
	[160,2,"Situs inversus",141,0  ],
	[161,1,"Head (CNS)",0,0  ],
	[162,2,"Brachycephaly",161,0  ],
	[163,2,"Dolichocephaly",161,0  ],
	[164,2,"Microcephaly",161,0  ],
	[165,2,"Prominet forehead",161,0  ],
	[166,2,"Prominet Occiput",161,0  ],
	[167,2,"Cloverleaf Shape",161,0  ],
	[168,2,"Lemon sign",161,0  ],
	[169,2,"Strawberry sign",161,0  ],
	[170,1,"Heart (Chest&Cardio)",0,0  ],
	[171,2,"4 Chambers View",170,0  ],
	[172,2,"Coractaion",170,0  ],
	[173,2,"Transposition",170,0  ],
	[174,2,"Dilation",170,0  ],
	[175,3,"Mild",174,0  ],
	[176,3,"Moderate",174,0  ],
	[177,3,"Severe",174,0  ],
	[178,2,"Dysrhythmia",170,0  ],
	[179,2,"Ebsteins Anomaly",170,0  ],
	[180,2,"Fallots Tetralogy",170,0  ],
	[181,2,"Pericardial effusions",170,0  ],
	[182,3,"Mild",181,0  ],
	[183,3,"Moderate",181,0  ],
	[184,3,"Severe",181,0  ],
	[185,2,"Septal Defect",170,0  ],
	[186,3,"Artium-Ventricle",185,0  ],
	[187,3,"Ventricle",185,0  ],
	[188,2,"Uni-ventricular",170,0  ],
	[189,2,"Uni-articular",170,0  ],
	[190,2,"Acardia",170,0  ],
	[191,1,"Kidneys (GUT)",0,0  ],
	[192,2,"Hydronephrosis",191,0  ],
	[193,3,"Left",192,0  ],
	[194,3,"Right",192,0  ],
	[195,3,"Left & Right",192,0  ],
	[196,2,"Pyelectasis (Pelviectasis)",191,0  ],
	[197,2,"Multicystic",191,0  ],
	[198,3,"Left",197,0  ],
	[199,3,"Right",197,0  ],
	[200,3,"Left & Right",197,0  ],
	[201,3,"MCDK",197,0  ],
	[202,2,"Polycystic",191,0  ],
	[203,3,"Left",202,0  ],
	[204,3,"Right",202,0  ],
	[205,3,"Left & Right",202,0  ],
	[206,2,"Renal Agenesis",191,0  ],
	[207,3,"Left",206,0  ],
	[208,3,"Right",206,0  ],
	[209,3,"Left & Right",206,0  ],
	[210,2,"Pelvic Kidney",191,0  ],
	[211,3,"Left",210,0  ],
	[212,3,"Right",210,0  ],
	[213,3,"Left & Right",210,0  ],
	[214,2,"Ureters",191,0  ],
	[215,3,"Left",214,0  ],
	[216,3,"Right",214,0  ],
	[217,3,"Left & Right",214,0  ],
	[218,3,"Mega Ureter",214,0  ],
	[219,2,"Adrenal Glands",191,0  ],
	[220,3,"Adrenal Tumor",219,0  ],
	[221,3,"Adrenal Cyst",219,0  ],
	[222,1,"Neck&Skin (Face&Neck)",0,0  ],
	[223,2,"Nuchal thickening",222,0  ],
	[224,2,"Cystic Hygromas",222,0  ],
	[225,3,"Mild",224,0  ],
	[226,3,"Moderate",224,0  ],
	[227,3,"Severe",224,0  ],
	[228,2,"Generalised Oedema",222,0  ],
	[229,3,"Mild",228,0  ],
	[230,3,"Moderate",228,0  ],
	[231,3,"Severe",228,0  ],
	[232,2,"Tumor",222,0  ],
	[233,1,"Skeleton & Musculature",0,0  ],
	[234,2,"Intrauterine fractures",233,0  ],
	[235,2,"Skeletal Shortining",233,0  ],
	[236,2,"Thanatophoric dwarfism",233,0  ],
	[237,2,"Achondrogenesis",233,0  ],
	[238,2,"Ostogenesis imperfect",233,0  ],
	[239,2,"Camptomelic Dysplasia",233,0  ],
	[240,2,"Short Rib Short Limb Syndrome",233,0  ],
	[241,2,"Ellis Van Crefeld syndrome",233,0  ],
	[242,2,"Chondrodystrophic Dystrophy",233,0  ],
	[243,2,"Arthogryposis multiplex congentia",233,0  ],
	[244,1,"Spine (Skeleton)",0,0  ],
	[245,2,"Hemivertbra",244,0  ],
	[246,3,"Cervical",245,0  ],
	[247,3,"Thoracic",245,0  ],
	[248,3,"Lumbar",245,0  ],
	[249,3,"Sacral",245,0  ],
	[250,3,"segments",245,0  ],
	[251,2,"Kyphosis",244,0  ],
	[252,3,"Cervical",251,0  ],
	[253,3,"Thoracic",251,0  ],
	[254,3,"Lumbar",251,0  ],
	[255,3,"Sacral",251,0  ],
	[256,3,"segments",251,0  ],
	[257,2,"Sacral agenesis",244,0  ],
	[258,2,"Sacrococcygal Teratoma",244,0  ],
	[259,3,"I external",258,0  ],
	[260,3,"II mainly exterrnal",258,0  ],
	[261,3,"III mainly internal",258,0  ],
	[262,3,"IV Internal",258,0  ],
	[263,2,"Sirenomelia",244,0  ],
	[264,2,"Scoliosis",244,0  ],
	[265,3,"Cervical",264,0  ],
	[266,3,"Thoracic",264,0  ],
	[267,3,"Lumbar",264,0  ],
	[268,3,"Sacral",264,0  ],
	[269,3,"segments",264,0  ],
	[270,2,"Meningocelle (Spina bifida)",244,0  ],
	[271,3,"Cervical",270,0  ],
	[272,3,"Thoracic",270,0  ],
	[273,3,"Lumbar",270,0  ],
	[274,3,"Sacral",270,0  ],
	[275,3,"segments",270,0  ],
	[276,2,"Meningomyelocelle (Spina bifida)",244,0  ],
	[277,3,"Cervical",276,0  ],
	[278,3,"Thoracic",276,0  ],
	[279,3,"Lumbar",276,0  ],
	[280,3,"Sacral",276,0  ],
	[281,3,"segments",276,0  ],
	[282,2,"Arnold Chiari Malformation",244,0  ],
	[283,3,"Cerebellum absent",282,0  ],
	[284,3,"Cerebellum banana",282,0  ],
	[285,3,"Lemon shaped Head",282,0  ],
	[286,1,"Thorax (Chest&Cardio)",0,0  ],
	[287,2,"Bronchogenic Cysts",286,0  ],
	[288,3,"Left",287,0  ],
	[289,3,"Right",287,0  ],
	[290,3,"Left & Right",287,0  ],
	[291,2,"Cystic-adenomatoid malformation",286,0  ],
	[292,3,"Macrocystic",291,0  ],
	[293,3,"Microcystict",291,0  ],
	[294,2,"Congenital diagphragmatic hernia",286,0  ],
	[295,3,"Stomach",294,0  ],
	[296,3,"Bowel",294,0  ],
	[297,3,"Liver",294,0  ],
	[298,3,"Pancreas",294,0  ],
	[299,2,"Hydrothorax",286,0  ],
	[300,3,"Left",299,0  ],
	[301,3,"Right",299,0  ],
	[302,3,"Left & Right",299,0  ],
	[303,2,"Sequestration",286,0  ],
	[304,3,"Extralobar",303,0  ],
	[305,3,"Intralobar",303,0  ],
	[306,2,"Hypoplasia",286,0  ],
	[307,3,"Left",306,0  ],
	[308,3,"Right",306,0  ],
	[309,3,"Left & Right",306,0  ],
	[310,2,"Mediastinal Shift",286,0  ],
	[311,3,"Mild",310,0  ],
	[312,3,"Moderate",310,0  ],
	[313,3,"Severe",310,0  ],
	[314,1,"General",0,0  ],
	[315,2,"Conditions",314,0  ],
	[316,3,"Multiple Malformations",315,0  ],
	[317,3,"IUGR",315,0  ],
	[318,3,"MACROSOMIA",315,0  ],
	[319,3,"Fetal Anemia",315,0  ],
	[320,3,"Single Umbilical Artery",315,0  ],
	[321,2,"Soft Markers",314,0  ],
	[322,3,"Ecogenic Bowel",321,0  ],
	[323,3,"Ecogenic Intracardiac Focus",321,0  ],
	[324,3,"Pyelectasis",321,0  ],
	[325,3,"CPC (Choroid Plexus Cyst)",321,0  ],
	[326,3,"Short Femur",321,0  ],
	[327,3,"Short Humerus",321,0  ],
	[328,3,"Cervical Cyst",321,0  ],
	[329,3,"Enlarged Nuchal Fold",321,0  ],
	[330,3,"more than one Soft Marker",321,0  ],
	[331,1,"Gynaecology",0,1  ],
	[332,2,"Symptoms",331,1  ],
	[333,3,"RLQ Abdominal Pain-[789.03.1]",332,1  ],
	[334,3,"LLQ Abdominal Pain-[789.04]",332,1  ],
	[335,3,"Abdominal Pain-[789.00]",332,1  ],
	[336,3,"Diffuse Abdominal Pain-[789.03.2]",332,1  ],
	[337,3,"Round Ligament Pain-[789.00]",332,1  ],
	[338,3,"Postcoital Abdominal pain-[789.00]",332,1  ],
	[339,3,"Postcoital Bleeding-[626.7]",332,1  ],
	[340,3,"Fever-[646.83]",332,1  ],
	[341,3,"Dysmenorrhea-[625.3]",332,1  ],
	[342,3,"Mittelschmerz-[625.2]",332,1  ],
	[343,3,"Superficial Dyspareunia-[625.0.1]",332,1  ],
	[344,3,"Deep Dyspareunia-[625.0.2]",332,1  ],
	[345,3,"Chronic Pelvic Pain-[625.9]",332,1  ],
	[346,3,"Dysuria-[788.1]",332,1  ],
	[347,3,"Urinary Incontinence-[788.30]",332,1  ],
	[348,3,"Hematuria-[599.89]",332,1  ],
	[349,3,"Nausea and Vomiting-[787.01]",332,1  ],
	[350,3,"Vaginal Bleeding-[623.8.1]",332,1  ],
	[351,3,"Vaginal Discharge-[623.5]",332,1  ],
	[352,3,"Cervical Bleeding-[622.8]",332,1  ],
	[353,3,"Postcoital Bleeding-[626.7.1]",332,1  ],
	[354,3,"Menorrhagia-[626.2.1]",332,1  ],
	[355,3,"Metrorrhagia-[626.6.1]",332,1  ],
	[356,3,"Menometrorrhagia-[626.2.2]",332,1  ],
	[357,3,"Amenorrhea-[626.0.1]",332,1  ],
	[358,3,"Hypomenorrhea-[626.1]",332,1  ],
	[359,3,"DUB, Dysfunctional Uterine Bleeding-[626.8]",332,1  ],
	[360,3,"PMB, Post Menopausal Bleeding-[627.1.1]",332,1  ],
	[361,3,"Vulvar Pruritus-[698.1]",332,1  ],
	[362,3,"Anemia-[285.9]",332,1  ],
	[363,3,"Diarrhea-[787.91]",332,1  ],
	[364,3,"Constipation-[564.00]",332,1  ],
	[365,3,"Fecal Incontinence-[787.60]",332,1  ],
	[366,3,"Vulvar Ulcer-[616.50.2]",332,1  ],
	[367,3,"Wound Infection-[998.59.2]",332,1  ],
	[368,3,"POVH, Post Operative Hernia-[553.21]",332,1  ],
	[369,3,"Vaginismus-[625.1]",332,1  ],
	[370,3,"Hydronephrosis-[591]",332,1  ],
	[371,3,"Hydroureter-[593.5]",332,1  ],
	[372,3,"Endometriosis in Scar-[617.6]",332,1  ],
	[373,3,"Obesity-[278.00]",332,1  ],
	[374,2,"Inflammatory Disease",331,1  ],
	[375,3,"PID, Pelvic Inflammatory Disease-[614.9.1]",374,1  ],
	[376,3,"Recurrent Pelvic Inflammatory Disease-[614.9.2]",374,1  ],
	[377,3,"Pyosalpinx-[614.2.1]",374,1  ],
	[378,3,"TOA, Tuboovarian Abscess-[614.2.2]",374,1  ],
	[379,3,"Fitz-Hugh-Curtis Synrome - Perihepatitis-[099.56]",374,1  ],
	[380,3,"Douglas Abscess-[614.4.1]",374,1  ],
	[381,3,"Pelvic Abscess-[614.4.2]",374,1  ],
	[382,3,"Sactosalpinx-[614.1.2]",374,1  ],
	[383,3,"Peritonitis-[567.9]",374,1  ],
	[384,3,"Acute Appendicitis-[540.9]",374,1  ],
	[385,3,"UTI, Urinary Tract Infection-[599.0]",374,1  ],
	[386,3,"Infected Endometrioma-[617.9.3]",374,1  ],
	[387,3,"Pyelonephritis-[590.80]",374,1  ],
	[388,3,"Pyometra-[615.9.1]",374,1  ],
	[389,3,"Vulvitis-[615.10.2]",374,1  ],
	[390,3,"Vaginitis-[615.10.3]",374,1  ],
	[391,3,"Labial Abscess-[616.4.1]",374,1  ],
	[392,3,"Vulvar Abscess-[616.4.2]",374,1  ],
	[393,3,"Bartholin Abscess-[616.3]",374,1  ],
	[394,3,"Infected Hematoma-[998.12]",374,1  ],
	[395,3,"Infected Endometrioma-[617.9.3]",374,1  ],
	[396,3,"Vaginal Cuff Hematoma-[623.6.1]",374,1  ],
	[397,3,"Endometritis-[615.9.2]",374,1  ],
	[398,3,"Endomyometritis(Postpartum/Postabortion)-[670.04.2]",374,1  ],
	[399,3,"Mastitis Postpartum-[675.24.1]",374,1  ],
	[400,3,"Sepsis-[038.9]",374,1  ],
	[401,3,"Postoperative Infection-[998.59]",374,1  ],
	[402,3,"Fever and Leukocytosis-[288.9]",374,1  ],
	[403,3,"Acute Gastroenteritis-[009.0]",374,1  ],
	[404,2,"Pregnancy",331,1  ],
	[405,3,"Ectopic Pregnancy-[633.80.1]",404,1  ],
	[406,3,"Ruptured Ectopic Pregnancy-[633.80.3]",404,1  ],
	[407,3,"Cervical Pregnancy-[633.80.4]",404,1  ],
	[408,3,"Ovarian Pregnancy-[633.20]",404,1  ],
	[409,3,"Normal Vaginal Pregnancy-[650]",404,1  ],
	[410,3,"Failed Mifegyne-[638.9]",404,1  ],
	[411,3,"Twin Pregnancy-[651.00]",404,1  ],
	[412,3,"Heterotopic Pregnancy-[633.91]",404,1  ],
	[413,3,"Early Pregnancy - Unknown Location-[629.9]",404,1  ],
	[414,3,"Blighted Ovum-[631]",404,1  ],
	[415,3,"Residua Postabortion-[631]",404,1  ],
	[416,3,"Tubal Abortion, Most Probably-[633.10]",404,1  ],
	[417,3,"Early Missed Abortion-[632.2]",404,1  ],
	[418,3,"Late Missed Abortion-[632.2]",404,1  ],
	[419,3,"Early Induced Abortion-[635.90.1]",404,1  ],
	[420,3,"Late Induced Abortion-[635.90.1]",404,1  ],
	[421,3,"Incomplete Abortion-[634.91.1]",404,1  ],
	[422,3,"Spontaneous Complete Abortion-[634.92]",404,1  ],
	[423,3,"Threatened Abortion-[640.00]",404,1  ],
	[424,3,"Septic Abortion-[636.00]",404,1  ],
	[425,3,"Hydatidiform Mole-[630]",404,1  ],
	[426,3,"Residua Postpartum-[667.14]",404,1  ],
	[427,3,"Residua Postabortion-[631]",404,1  ],
	[428,3,"Placenta Previa-[641.00]",404,1  ],
	[429,3,"Subchorionic Hematoma-[641.23]",404,1  ],
	[430,3,"Pregnancy in Previous Cesarean Scar-[671.4]",404,1  ],
	[431,3,"Hyperemesis Gravidarum-[643.00]",404,1  ],
	[432,3,"Inevitable Abortion-[634.91.2]",404,1  ],
	[433,3,"Second Trimester Bleeding-[641.80]",404,1  ],
	[434,3,"UTI, Urinary Tract Infection-[599.0]",404,1  ],
	[435,3,"Pyelonephritis-[590.80]",404,1  ],
	[436,3,"Renal Colic-[788.0]",404,1  ],
	[437,3,"Hypertension Complicating Pregnancy-[642.90]",404,1  ],
	[438,3,"Headache in Pregnancy-[784.0]",404,1  ],
	[439,3,"Habitual Abortion-[646.30]",404,1  ],
	[440,3,"DIC, Disseminated Intravascular Coagulation-[286.6]",404,1  ],
	[441,3,"Amniotic Fluid Embolism-[673.10]",404,1  ],
	[442,3,"Amnionitis-[762.7]",404,1  ],
	[443,3,"Premature Contractions-[763.7]",404,1  ],
	[444,3,"PPROM-[658.10]",404,1  ],
	[445,3,"Trauma in Pregnancy-[665.93]",404,1  ],
	[446,3,"Intrauterine Pregnancy-[V22.1]",404,1  ],
	[447,2,"Puerperium",331,1  ],
	[448,3,"Puerperal Fever-[672.04]",447,1  ],
	[449,3,"Engorgement of Breast-[676.24]",447,1  ],
	[450,3,"Mastitis-[675.84]",447,1  ],
	[451,3,"UTI, Urinary Tract Infection-[646.64]",447,1  ],
	[452,3,"Thrombophlebitis-[671.24]",447,1  ],
	[453,3,"Residua, Unspecified-[667.14]",447,1  ],
	[454,3,"Endometritis/Endomyometritis-[670.04.1]",447,1  ],
	[455,3,"E-PPH, Early Postpartum Hemorrhage-[666.10]",447,1  ],
	[456,3,"L-PPH, Late Postpartum Hemorrhage-[666.20]",447,1  ],
	[457,3,"Anemia-[648.24]",447,1  ],
	[458,3,"Placental Site Bleeding-[666.10]",447,1  ],
	[459,3,"AVM, Arterio-Venous Malformation-[747.60]",447,1  ],
	[460,3,"Wound Infection-[674.30]",447,1  ],
	[461,3,"Broad Ligament Hematoma-[665.74.1]",447,1  ],
	[462,3,"Abdominal Wall Hematoma-[665.74.2]",447,1  ],
	[463,3,"Infected Hematoma-[998.59.1]",447,1  ],
	[464,3,"Postpartum Hypertension-[642.94]",447,1  ],
	[465,3,"Disruption of External Operation Wound-[998.32]",447,1  ],
	[466,3,"DVT, Deep Vein Thrombosis-[671.44]",447,1  ],
	[467,3,"Postpartum Fever-[672.0]",447,1  ],
	[468,2,"Adnexal findings",331,1  ],
	[469,3,"Simple Ovarian Cyst-[620.2.2]",468,1  ],
	[470,3,"Functional Ovarian Cyst-[620.2.3]",468,1  ],
	[471,3,"Hemorrhagic Corpus Luteum-[620.1]",468,1  ],
	[472,3,"Corpus Luteum Hemorrhage or Rupture-[620.1]",468,1  ],
	[473,3,"Corpus Luteum Cyst or Hematoma-[620.1]",468,1  ],
	[474,3,"Paraovarian Cyst-[752.11.1]",468,1  ],
	[475,3,"Ovarian Cyst-[620.2.1]",468,1  ],
	[476,3,"Dermoid Cysts-[220.1]",468,1  ],
	[477,3,"Endometrioma-[617.9.1]",468,1  ],
	[478,3,"Endometriosis-[617.9.2]",468,1  ],
	[479,3,"Serous Cystadenoma-[236.2]",468,1  ],
	[480,3,"Mucinous Cystadenoma-[236.2]",468,1  ],
	[481,3,"Sactosalpinx-[614.1]",468,1  ],
	[482,3,"Hydrosalpinx-[614.1.1]",468,1  ],
	[483,3,"Torsion of Adnexa-[620.5.1]",468,1  ],
	[484,3,"Torsion of Ovary-[620.5.2]",468,1  ],
	[485,3,"Torsion of Fallopian Tube-[620.5.3]",468,1  ],
	[486,3,"PCO, Polycystic Ovaries-[256.4]",468,1  ],
	[487,3,"Proximal Tubal Occlusion-[614.6.2]",468,1  ],
	[488,3,"Prophylactic BSO (BRCA+)-[V50.42]",468,1  ],
	[489,3,"Prolapse of Fallopian Tube-[620.4]",468,1  ],
	[490,2,"Vulvar and perineal pathology",331,1  ],
	[491,3,"Bartholins gland Abscess-[616.3]",490,1  ],
	[492,3,"Labial Abscess-[624.8]",490,1  ],
	[493,3,"Bartholin Cyst-[616.2]",490,1  ],
	[494,3,"Labial Cyst-[624.8.1]",490,1  ],
	[495,3,"Imperforate Hymen-[752.42.1]",490,1  ],
	[496,3,"Hymenal Bridge-[752.40.2]",490,1  ],
	[497,3,"Episiotomy Related Dyspareunia-[625.3]",490,1  ],
	[498,3,"Vulvar Sebaceous Cyst-[706.2]",490,1  ],
	[499,3,"Trichomonal Vulvovaginitis-[131.01]",490,1  ],
	[500,3,"Candidiasis of Vulva and/or Vagina-[112.1]",490,1  ],
	[501,3,"Vulvar Nevus-[448.1]",490,1  ],
	[502,3,"Chancroid-[099.0]",490,1  ],
	[503,3,"Skin Tag-[624.8.2]",490,1  ],
	[504,3,"Herpes Genitalis-[054.10]",490,1  ],
	[505,3,"Condyloma Acuminata-[078.11]",490,1  ],
	[506,3,"Veneral disease of the Lower Genitourinary Tract-[099.9]",490,1  ],
	[507,3,"Foreign Body in Vagina-[939.2]",490,1  ],
	[508,3,"Vulvar Ulcer-[616.50.2]",490,1  ],
	[509,3,"Kissing Ulcers-[616.50.1]",490,1  ],
	[510,3,"Lymphogranuloma Venereum-[099.1]",490,1  ],
	[511,3,"Vulvar Leukoplakia-[624.09]",490,1  ],
	[512,3,"Hypertrophy of Labia-Unilateral-[624.3]",490,1  ],
	[513,3,"Hypertrophy of Labia-Bilateral-[624.3]",490,1  ],
	[514,3,"Early menarche-[256.39.1]",490,1  ],
	[515,3,"Late menarche-[256.39.2]",490,1  ],
	[516,3,"Late menopause-[256.39.3]",490,1  ],
	[517,3,"Endometriosis-[617.9.4]",490,1  ],
	[518,3,"Sexual Assault-Adult-[995.83]",490,1  ],
	[519,3,"Sexual Assault-Child-[E967.9]",490,1  ],
	[520,2,"Benign Uterine Pathology",331,1  ],
	[521,3,"Thick Endometrium-[621.30]",520,1  ],
	[522,3,"Adenomyosis-[617.0]",520,1  ],
	[523,3,"Uterine Myomatosus-[218.9.1]",520,1  ],
	[524,3,"Hematometra-[621.4]",520,1  ],
	[525,3,"Pyometra-[615.9.1]",520,1  ],
	[526,3,"Myoma Nascens-[218.9.2]",520,1  ],
	[527,3,"Uterine Polyp-[621.0]",520,1  ],
	[528,3,"Retroversion Flexion-[621.6]",520,1  ],
	[529,3,"Allen-Masters (Universal Joint Syndrome)-[620.6]",520,1  ],
	[530,3,"Uterus Descensus-[618.1.2]",520,1  ],
	[531,3,"Elongatio Colli-[622.6.1]",520,1  ],
	[532,3,"Degenerated Myoma-[218.9.3]",520,1  ],
	[533,3,"Intraligamentary Myoma-[218.9.4]",520,1  ],
	[534,3,"Submucous Myoma-[218.0]",520,1  ],
	[535,3,"Intramural Myoma-[218.1]",520,1  ],
	[536,3,"Subserous Myoma-[218.2]",520,1  ],
	[537,3,"Intrauterine Adhesions-[621.5]",520,1  ],
	[538,3,"Ashermans Syndrome-[621.5]",520,1  ],
	[539,3,"Intraperitoneal Adhesions-[568.0]",520,1  ],
	[540,3,"PMB, Postmenopausal Bleeding-[627.1.2]",520,1  ],
	[541,3,"Perimenopausal Bleeding-[627.1]",520,1  ],
	[542,3,"IUD in situ-[996.65]",520,1  ],
	[543,3,"Lost IUD-[996.65]",520,1  ],
	[544,3,"Didelphic Uterus-[752.2]",520,1  ],
	[545,3,"Menorrhagia-[626.2.1]",520,1  ],
	[546,3,"Metrorrhagia-[626.6.1]",520,1  ],
	[547,3,"Amenorrhea-[626.0.1]",520,1  ],
	[548,3,"Menometrorrhagia-[626.2.2]",520,1  ],
	[549,3,"Pelvic Endometriosis-[617.9.3]",520,1  ],
	[550,3,"Simple Hyperplasia-[621.31]",520,1  ],
	[551,3,"Complex Hyperplasia-[621.32]",520,1  ],
	[552,3,"Perforation of Uterine Wall-[867.4]",520,1  ],
	[553,3,"Uterine Septum-[752.39]",520,1  ],
	[554,3,"Uterus Unicornis-[752.39]",520,1  ],
	[555,3,"Bicornuate Uterus-[752.39]",520,1  ],
	[556,3,"Bicornuate Non Communicating Uterus-[752.39]",520,1  ],
	[557,2,"S/P OBGYN Operations",331,1  ],
	[558,3,"S/P Cesarean Section-[654.20]",557,1  ],
	[559,3,"S/P Cervical Conization-[654.60]",557,1  ],
	[560,3,"S/P Trachelectomy-[654.60]",557,1  ],
	[561,3,"S/P TAH-[629.9]",557,1  ],
	[562,3,"S/P TAH+BSO-[629.9]",557,1  ],
	[563,3,"S/P Radical Hysterectomy-[629.9]",557,1  ],
	[564,3,"S/P Vaginal Hysterectomy-[629.9]",557,1  ],
	[565,3,"S/P Laparoscopic Hysterectomy-[629.9]",557,1  ],
	[566,3,"S/P Ovarian Cystectomy-[629.9]",557,1  ],
	[567,3,"S/P BSO-[629.9]",557,1  ],
	[568,3,"S/P Radiotherapy-[V67.1]",557,1  ],
	[569,3,"S/P Chemotherapy-[V67.1]",557,1  ],
	[570,3,"S/P Chemoradiation-[V67.51]",557,1  ],
	[571,3,"S/P Vulvectomy-[629.9]",557,1  ],
	[572,3,"S/P Vaginectomy-[629.9]",557,1  ],
	[573,3,"S/P Laparoscopic USO-[629.9]",557,1  ],
	[574,3,"S/P Laparoscopic BSO-[629.9]",557,1  ],
	[575,3,"S/P Laparoscopic Cystectomy-[629.9]",557,1  ],
	[576,3,"S/P Laparoscopic Detorsion of Adnexa-[620.5]",557,1  ],
	[577,3,"S/P Lap Salpingectomy due to EUP-[633.80]",557,1  ],
	[578,3,"S/P Ectopic Pregnancy-[633.80]",557,1  ],
	[579,3,"S/P D+C-[629.9]",557,1  ],
	[580,3,"S/P D+E-[629.9]",557,1  ],
	[581,3,"S/P TOP by Mifegyne + Cytotec-[779.6]",557,1  ],
	[582,3,"S/P Methotrexate Treatment-[760.78]",557,1  ],
	[583,3,"S/P IVF-[628.9]",557,1  ],
	[584,3,"S/P Ovulation Induction-[628.9]",557,1  ],
	[585,3,"S/P Appendectomy-[211.3]",557,1  ],
	[586,3,"S/P LN Dissection-[196.9]",557,1  ],
	[587,3,"S/P Ant Colporrhaphy-[629.9]",557,1  ],
	[588,3,"S/P Post Colporrhaphy-[629.9]",557,1  ],
	[589,3,"S/P TOT-[629.9]",557,1  ],
	[590,2,"S/P OBGYN Operations",331,1  ],
	[591,3,"Elongatio Colli-[622.6.1]",557,1  ],
	[592,3,"Uterine Prolapse-[618.1]",557,1  ],
	[593,3,"Uterus Descensus-[618.1.2]",557,1  ],
	[594,3,"Total Uterine Prolapse-[618.3]",557,1  ],
	[595,3,"Pelvic Organ Prolapse-[618.9]",557,1  ],
	[596,3,"Inversion of Vaginal Walls-[618.00.1]",557,1  ],
	[597,3,"Cystocele-[618.01.1]",557,1  ],
	[598,3,"Urethrocele-[618.03]",557,1  ],
	[599,3,"Rectocele-[618.04.1]",557,1  ],
	[600,3,"Enterocele-[618.6]",557,1  ],
	[601,3,"Recto-Enterocele-[618.04.2]",557,1  ],
	[602,3,"Vaginal Vault Prolapse-[618.5]",557,1  ],
	[603,3,"SUI, Stress Urinary Incontinence-[625.6.1]",557,1  ],
	[604,3,"Mixed Urinary Incontinence-[788.33]",557,1  ],
	[605,3,"Urgency Incontinence-[788.31]",557,1  ],
	[606,3,"Detrusor Overactivity-[596.59]",557,1  ],
	[607,3,"Urinary Retention-[788.20]",557,1  ],
	[608,3,"Vesico-Vaginal Fistula-[619.0.1]",557,1  ],
	[609,3,"Uretero-Vaginal Fistula-[619.0.2]",557,1  ],
	[610,3,"Urethrovaginal Fistula-[619.0]",557,1  ],
	[611,3,"Recto-Vaginal Fistula-[619.1]",557,1  ],
	[612,3,"Endometriosis of Rectovaginal Septum-[617.4]",557,1  ],
	[613,3,"Urethral Diverticulum-[599.2]",557,1  ],
	[614,3,"Bladder Outlet Obstruction-[596.0]",557,1  ],
	[615,3,"Roomy Vagina-[654.70]",557,1  ],
	[616,3,"Erosion of Mesh / Sling-[521.34]",557,1  ],
	[617,2,"Benign cervical and vaginal pathology",331,1  ],
	[618,3,"Cervical Polyp-[622.7]",617,1  ],
	[619,3,"Cervical Ectropion-[622.0]",617,1  ],
	[620,3,"Postcoital Bleeding-[626.7.1]",617,1  ],
	[621,3,"Malformed Cervix-[752.40.1]",617,1  ],
	[622,3,"Distorted Cervix-[622.4]",617,1  ],
	[623,3,"Cervical Stenosis-[622.4]",617,1  ],
	[624,3,"Decidual Polyp-[674.40]",617,1  ],
	[625,3,"CIN-I, Cervical Intraepithelial Neoplasia-[622.11]",617,1  ],
	[626,3,"CIN II, Cervical Intraepithelial Neoplasia-[622.12]",617,1  ],
	[627,3,"CIN-III, Cervical Intraepithelial Neoplasia-[233.1.3]",617,1  ],
	[628,3,"Cervical Incompetence-[622.5]",617,1  ],
	[629,3,"Portio Vaginalis Short, S/P Cervical Conization-[623.9.1]",617,1  ],
	[630,3,"Gartner Cyst-[752.41]",617,1  ],
	[631,3,"Vaginal Cuff Hematoma-[623.6.1]",617,1  ],
	[632,3,"Vaginal Thrombus-[665.74]",617,1  ],
	[633,3,"Septated Vagina-Longitudinal Septum-[752.49.1]",617,1  ],
	[634,3,"Septated Vagina-Transverse Septum-[752.49.3]",617,1  ],
	[635,3,"Imperforated Hymen-[752.42.1]",617,1  ],
	[636,3,"Vaginal Cyst, Unspecified-[752.41]",617,1  ],
	[637,3,"Intracervical Adhesions-[622.4]",617,1  ],
	[638,3,"Atrophic Vaginitis-[627.3]",617,1  ],
	[639,3,"Vaginal Tear-[623.4]",617,1  ],
	[640,3,"Vaginal Stenosis-[623.2]",617,1  ],
	[641,3,"Cervical Leiomyoma-[654.10]",617,1  ],
	[642,3,"LG-SIL, Low Grade Squamous Intraepithelial Lesion-[795.03]",617,1  ],
	[643,3,"HG-SIL, High Grade Squamous Intraepithelial Lesion-[795.04]",617,1  ],
	[644,2,"Malignancy of uterus",331,1  ],
	[645,3,"Endometrial Carcinoma-[182.0.2]",644,1  ],
	[646,3,"Unstaged Endometrial Carcinoma-[182.0.1]",644,1  ],
	[647,3,"Uterine Malignancy, NOS-[179.1]",644,1  ],
	[648,3,"Uterine Leiomyosarcoma-[179.3]",644,1  ],
	[649,3,"Mixed Mullerian Tumor of Uterus-[179.4]",644,1  ],
	[650,3,"Undifferentiated Sarcoma of Uterus-[179.5]",644,1  ],
	[651,3,"Low Grade Stromal Sarcoma of Uterus-[182.0.3]",644,1  ],
	[652,3,"Leiomyomatosis-[236.0]",644,1  ],
	[653,3,"Serous Papillary Endometrial Carcinoma-[182.0.4]",644,1  ],
	[654,3,"Endometrioid Endometrial Carcinoma-[182.0.5]",644,1  ],
	[655,2,"Malignancy of vulva and vagina",331,1  ],
	[656,3,"Vulvar Carcinoma-[184.4.2]",655,1  ],
	[657,3,"Microinvasive Vulvar Carcinoma-[184.4.3]",655,1  ],
	[658,3,"One-Sided Vulvar Carcinoma-[184.4.4]",655,1  ],
	[659,3,"Bilateral Vulvar Carcinoma-[184.4.5]",655,1  ],
	[660,3,"Carcinoma of Vulva Involving Clitoris-[184.4.1]",655,1  ],
	[661,3,"Vulvar Intraepithelial Neoplasia-[624.9]",655,1  ],
	[662,3,"Melanoma of Vulva-[184.4.6]",655,1  ],
	[663,3,"Malignant Neoplasm of Vulva-[184.4.7]",655,1  ],
	[664,3,"Malignancy of Vagina-[184.0.2]",655,1  ],
	[665,3,"Carcinoma of Vagina-[184.0.1]",655,1  ],
	[666,3,"Vaginal Intraepithelial Neoplasia-[623.0]",655,1  ],
	[667,2,"Malignancy of Cervix",331,1  ],
	[668,3,"Squamous Cell Carcinoma in situ of Cervix-[233.1.1]",667,1  ],
	[669,3,"Adenocarcinoma in situ of Cervix-[233.1.2]",667,1  ],
	[670,3,"Invasive Sqamous Cell Carcinoma of Cervix-[180.9.1]",667,1  ],
	[671,3,"Invasive Adenocarcinoma of Cervix-[180.9.2]",667,1  ],
	[672,3,"Localized Cervical Carcinoma-[180.9.3]",667,1  ],
	[673,3,"Metastatic Cervical Carcinoma-[198.82]",667,1  ],
	[674,3,"Microinvasive Cervical Carcinoma-[180.9.4]",667,1  ],
	[675,3,"Cervical Sarcoma-[180.9.5]",667,1  ],
	[676,3,"Cervical Carcinoma, S/P Neoadjuvant Chemotherapy-[180.9.6]",667,1  ],
	[677,3,"Cervical Carcinoma, S/P Chemoradiation-[180.9.7]",667,1  ],
	[678,2,"Infertility",331,1  ],
	[679,3,"Antepartum condition or complication-[651.73]",678,1  ],
	[680,2,"Pelvic tumor",331,1  ],
	[681,3,"Pelvic Tumor, Unspecified-[238.8]",680,1  ],
	[682,3,"Benign Ovarian Tumor-[220.2]",680,1  ],
	[683,3,"Pedunculated Myoma-[229.8]",680,1  ],
	[684,2,"Obstetrics",331,1  ],
	[685,3,"Dysfunctional Labor-[660.90]",684,1  ],
	[686,3,"Failed Induction-[660.90]",684,1  ],
	[687,3,"Arrest of Dilatation-[660.90]",684,1  ],
	[688,3,"Arrest of Decent-[660.90]",684,1  ],
	[689,3,"Prolonged Latent Phase-[660.90]",684,1  ],
	[690,3,"Prolonged Second Stage-[660.90]",684,1  ],
	[691,3,"Prolonged Deceleration Phase-[660.90]",684,1  ],
	[692,3,"Relative CPD-[653.40]",684,1  ],
	[693,3,"Non-Reassuring Fetal Heart Rate-[659.7]",684,1  ],
	[694,3,"Suspected Fetal Distress-[768.4]",684,1  ],
	[695,3,"Breech Presentation-[761.7]",684,1  ],
	[696,3,"Past Shoulder Dystocia-[660.40]",684,1  ],
	[697,3,"Previous Cesarean Section-[654.21]",684,1  ],
	[698,3,"Elective CS-[V50.9]",684,1  ],
	[699,3,"Transverse or Oblique Lie-[652.31]",684,1  ],
	[700,3,"Other Malposition or Malpresentation-[652.81]",684,1  ],
	[701,3,"Prolapse of Cord-[663.00]",684,1  ],
	[702,3,"PROM-[658.13]",684,1  ],
	[703,3,"Macrosomia-[656.60]",684,1  ],
	[704,3,"Suspected Macrosomia-[656.60]",684,1  ],
	[705,3,"Twin Pregnancy-[651.00]",684,1  ],
	[706,3,"Twin Pregnancy - 1st Non-Vertex-[651.00]",684,1  ],
	[707,3,"Placenta Previa-[641.00]",684,1  ],
	[708,3,"Complete Placenta Previa-[641.00]",684,1  ],
	[709,3,"Partial Placenta Previa-[641.00]",684,1  ],
	[710,3,"Marginal Placenta Previa-[641.00]",684,1  ],
	[711,3,"Low Lying Placenta-[641.00]",684,1  ],
	[712,3,"Bleeding Placenta Previa-[641.00]",684,1  ],
	[713,3,"Placental Abruption-[641.00]",684,1  ],
	[714,3,"Vasa Previa-[663.50]",684,1  ],
	[715,3,"Previous LSTCS-[654.20]",684,1  ],
	[716,3,"Previous Cesarean Section-[654.20]",684,1  ],
	[717,3,"Previous Corporeal Cesarean Section-[654.20]",684,1  ],
	[718,3,"Suspected Chorioamnionitis-[658.40]",684,1  ],
	[719,3,"Genital Herpes-[054.10]",684,1  ],
	[720,3,"GDMA1-[648.8]",684,1  ],
	[721,3,"GDMA2-[648.8]",684,1  ],
	[722,3,"IUGR-[764.9]",684,1  ],
	[723,3,"PPROM-[658.13]",684,1  ],
	[724,3,"Active Labor-[V22.2]",684,1  ],
	[725, 1, "MFM", 0, 0],
	[726, 2, "Monochorionic twins", 725, 0],
	[727, 3, "UNCOMPLICATED - MONOCHORIONIC TWINS", 726, 0,"UNCOMPLICATED - MONOCHORIONIC TWINS"],
	[728, 3, "ACARDIAC TWIN - MONOCHORIONIC TWINS", 726, 0,"ACARDIAC TWIN - MONOCHORIONIC TWINS"],
	[729, 3, "MONOAMNIOTIC - MONOCHORIONIC TWINS", 726, 0,"MONOAMNIOTIC - MONOCHORIONIC TWINS"],
	[730, 3, "MONOAMNIOTIC - MONOCHORIONIC TWINS-cord entanglement", 726, 0,"MONOAMNIOTIC - MONOCHORIONIC TWINS-cord entanglement"],
	[731, 3, "IUFD (INTRAUTERINE DEATH) OF CO-TWIN", 726, 0,"Monochorionic twins IUFD (INTRAUTERINE DEATH) OF CO-TWIN"],
	[732, 3, "CONJOINED TWINS", 726, 0,"Monochorionic twins CONJOINED TWINS"],
	[733, 3, "SELECTIVE IUGR - MONOCHORIONIC TWINS-NOS", 726, 0,"SELECTIVE IUGR - MONOCHORIONIC TWINS-NOS"],
	[734, 3, "SELECTIVE IUGR - MONOCHORIONIC TWINS-TYPE 1", 726, 0,"Monochorionic twins SELECTIVE IUGR - MONOCHORIONIC TWINS-TYPE 1"],
	[735, 3, "SELECTIVE IUGR - MONOCHORIONIC TWINS-TYPE 2", 726, 0,"Monochorionic twins SELECTIVE IUGR - MONOCHORIONIC TWINS-TYPE 2"],
	[736, 3, "SELECTIVE IUGR - MONOCHORIONIC TWINS-TYPE 3", 726, 0,"SELECTIVE IUGR - MONOCHORIONIC TWINS-TYPE 3"],
	[737, 3, "TWIN REVERSED ARTERIAL PERFUSION (TRAPS) - MONOCHORIONIC TWINS", 726, 0,"Monochorionic twins  TWIN REVERSED ARTERIAL PERFUSION (TRAPS) - MONOCHORIONIC TWINS "],
	[738, 3, "TWIN TO TWIN TRANSFUSION SYNDROME (TTTS) - MONOCHORIONIC TWINS", 726, 0,"Monochorionic twins TWIN TO TWIN TRANSFUSION SYNDROME (TTTS) - MONOCHORIONIC TWINS "],
	[739, 3, "AMNIOTIC FLUID VOLUME DISCORDANCE - MONOCHORIONIC TWINS", 726, 0,"Monochorionic twins AMNIOTIC FLUID VOLUME DISCORDANCE - MONOCHORIONIC TWINS "],
	[740, 3, "TTTS-STAGE 1", 726, 0,"Monochorionic twins TTTS-STAGE 1"],
	[741, 3, "TTTS-STAGE 2", 726, 0,"Monochorionic twins TTTS-STAGE 2"],
	[742, 3, "TTTS-STAGE 3", 726, 0,"Monochorionic twins TTTS-STAGE 3"],
	[743, 3, "TTTS-STAGE 4", 726, 0,"Monochorionic twins TTTS-STAGE 4"],
	[744, 3, "TTTS-STAGE 5", 726, 0,"Monochorionic twins TTTS-STAGE 5"],
	[745, 3, "TWIN ANEMIA POLYCYTHEMIA SEQUENCE (TAPS)-NOS", 726, 0,"Monochorionic twins TWIN ANEMIA POLYCYTHEMIA  SEQUENCE (TAPS)-NOS"],
	[746, 3, "TAPS- STAGE 1", 726, 0,"Monochorionic twins TAPS- STAGE 1"],
	[747, 3, "TAPS- STAGE 2", 726, 0,"Monochorionic twins TAPS- STAGE 2"],
	[748, 3, "TAPS- STAGE 3", 726, 0,"Monochorionic twins TAPS- STAGE 3"],
	[749, 3, "TAPS- STAGE 4", 726, 0,"Monochorionic twins TAPS- STAGE 4"],
	[750, 3, "TAPS- STAGE 5", 726, 0,"Monochorionic twins TAPS- STAGE 5"],
	[751, 3, "TWIN DISCORDANCE FOR ABNORMALITY", 726, 0,"Monochorionic twins TWIN DISCORDANCE FOR ABNORMALITY"],
	[752, 3, "MONOCHORIONIC TWINS DISCORDANT GROWTH", 726, 0,"Monochorionic twins MONOCHORIONIC TWINS DISCORDANT GROWTH"],
	[753, 3, "X - SPECIFIED IN TEXT - MONOCHORIONIC TWINS FINDING", 726, 0,"Monochorionic twins  X - SPECIFIED IN TEXT - MONOCHORIONIC TWINS FINDING "],
	[754, 2, "TRIPLET PREGNANCY", 725, 0],
	[755, 3, "TRIPLET PREGNANCY- TRICHORIONIC TRIAMNIOTIC", 754, 0, "TRIPLET PREGNANCY- TRICHORIONIC TRIAMNIOTIC"],
	[756, 3, "TRIPLET PREGNANCY- BICHORIONIC TRIAMNIOTIC", 754, 0,"TRIPLET PREGNANCY- BICHORIONIC TRIAMNIOTIC"],
	[757, 3, "TRIPLET PREGNANCY- MONOCHORIONIC TRIAMNIOTIC", 754, 0,"TRIPLET PREGNANCY- MONOCHORIONIC TRIAMNIOTIC"],
	[758, 3, "TRIPLET PREGNANCY-BICHORIONIC BIAMNIOTIC", 754, 0,"TRIPLET PREGNANCY-BICHORIONIC BIAMNIOTIC"],
	[759, 3, "TRIPLET PREGNANCY- MONOCHORIONIC BIAMNIOTIC", 754, 0,"TRIPLET PREGNANCY- MONOCHORIONIC BIAMNIOTIC"],
	[760, 3, "TRIPLET PREGNANCY-MONOCHORIONIC MONOAMNIOTIC", 754, 0,"TRIPLET PREGNANCY-MONOCHORIONIC MONOAMNIOTIC"],
	[761, 2, "QUADRIPLET PREGNANCY", 725, 0,"QUADRIPLET PREGNANCY "],
	[762, 2, "QUINTUPLET PREGNANCY", 725, 0,"QUINTUPLET PREGNANCY "],
	[763, 2, "CMV IN PREGNANCY", 725, 0],
	[764, 3, "FETAL INFECTION - CMV IN PREGNANCY", 763, 0,"FETAL INFECTION - CMV IN PREGNANCY"],
	[765, 3, "NON-PRIMARY MATERAL INFECTION - CMV IN PREGNANCY", 763, 0,"NON-PRIMARY MATERAL INFECTION - CMV IN PREGNANCY"],
	[766, 3, "PRECONCEPTION MATERNAL INFECTION - CMV IN PREGNANCY", 763, 0,"PRECONCEPTION MATERNAL INFECTION - CMV IN PREGNANCY"],
	[767, 3, "PRIMARY MATERNAL INFECTION - CMV IN PREGNANCY", 763, 0,"PRIMARY MATERNAL INFECTION - CMV IN PREGNANCY"],
	[768, 3, "MATERNAL RE-INFECTION - CMV IN PREGNANCY", 763, 0, "MATERNAL RE-INFECTION - CMV IN PREGNANCY"],
	[769, 3, "X - SPECIFIED IN TEXT - CMV IN PREGNANCY", 763, 0,"X - SPECIFIED IN TEXT - CMV IN PREGNANCY"],
	[770, 2, "FETAL ANEMIA", 725, 0],
	[771, 3, "PARVOVIRUS INFECTION", 770, 0,"FETAL ANEMIA PARVOVIRUS INFECTION"],
	[772, 3, "PARVOVIRUS INFECTION- FETAL ANEMIA", 770, 0,"FETAL ANEMIA PARVOVIRUS INFECTION- FETAL ANEMIA"],
	[773, 3, "RBC ALLOIMMUNIZATION - ATYPICAL ANTIGENS - FETAL ANEMIA", 770, 0,"FETAL ANEMIA  RBC ALLOIMMUNIZATION - ATYPICAL ANTIGENS - FETAL ANEMIA "],
	[774, 3, "RBC ALLOIMMUNIZATION - RH", 770, 0,"FETAL ANEMIA RBC ALLOIMMUNIZATION - RH "],
	[775, 3, "RBC ALLOIMMUNIZATION - RH - FETAL ANEMIA", 770, 0,"FETAL ANEMIA RBC ALLOIMMUNIZATION - RH - FETAL ANEMIA "],
	[776, 3, "FETAL ANEMIA SUSPECTED- NOS", 770, 0,"FETAL ANEMIA FETAL ANEMIA SUSPECTED- NOS"],
	[777, 3, "FETAL HYDROPS", 770, 0,"FETAL ANEMIA FETAL HYDROPS"],
	[778, 3, "FETAL THALASSEMIA", 770, 0,"FETAL ANEMIA FETAL THALASSEMIA"],
	[779, 3, "MATERNAL FETAL HEMMORAGE", 770, 0,"FETAL ANEMIA MATERNAL FETAL HEMMORAGE"],
	[780, 3, "X - SPECIFIED IN TEXT - FETAL ANEMIA FINDING", 770, 0,"FETAL ANEMIA  X - SPECIFIED IN TEXT - FETAL ANEMIA FINDING"],
	[781, 2, "NEONATAL ALLOIMMUNE THROMBOCYTOPENIA", 725, 0,"NEONATAL ALLOIMMUNE THROMBOCYTOPENIA"],
	[782, 2, "FETAL ARRYTHMIA", 725, 0],
	[783, 3, "FETAL TACHYARRYTHMIA -SVT", 782, 0,"FETAL ARRYTHMIA FETAL TACHYARRYTHMIA -SVT"],
	[784, 3, "FETAL TACHYARRYTHMIA - ATRIAL FIBRILLATION", 782, 0,"FETAL ARRYTHMIA FETAL TACHYARRYTHMIA - ATRIAL FIBRILLATION"],
	[785, 3, "FFETAL TACHYARRYTHMIA - ATRIAL FLUTTER", 782, 0,"FETAL ARRYTHMIA FFETAL TACHYARRYTHMIA - ATRIAL FLUTTER"],
	[786, 3, "FETAL TACHYARRYTHMIA-VT", 782, 0,"FETAL ARRYTHMIA FETAL TACHYARRYTHMIA-VT"],
	[787, 3, "FETAL BRADYARRYTHMIA", 782, 0,"FETAL ARRYTHMIA FETAL BRADYARRYTHMIA"],
	[788, 3, "FETAL HEART BLOCK", 782, 0,"FETAL ARRYTHMIA FETAL HEART BLOCK"],
	[789, 3, "FETAL ARRYTHMIA - NOS", 782, 0,"FETAL ARRYTHMIA FETAL ARRYTHMIA - NOS"],
	[790, 2, "FETAL CARDIAC LESIONS", 725, 0,"FETAL CARDIAC LESIONS FETAL CARDIAC LESIONS"],
	[791, 3, "FETAL AORTIC STENOSIS", 790, 0,"FETAL CARDIAC LESIONS FETAL AORTIC STENOSIS"],
	[792, 3, "FETAL PULMONIC STENOSIS", 790, 0,"FETAL CARDIAC LESIONS FETAL PULMONIC STENOSIS"],
	[793, 3, "FETAL MITRAL STENOSIS", 790, 0,"FETAL CARDIAC LESIONS FETAL MITRAL STENOSIS"],
	[794, 3, "FETAL TRICUSPID STENOSIS", 790, 0,"FETAL CARDIAC LESIONS FETAL TRICUSPID STENOSIS"],
	[795, 3, "FETAL AORTIC REGURGITATION", 790, 0,"FETAL CARDIAC LESIONS FETAL AORTIC REGURGITATION"],
	[796, 3, "FETAL PULMONIC REGURGITATION", 790, 0,"FETAL CARDIAC LESIONS FETAL PULMONIC REGURGITATION"],
	[797, 3, "FETAL MITRAL REGURGITATION", 790, 0,"FETAL CARDIAC LESIONS FETAL MITRAL REGURGITATION"],
	[798, 3, "FETAL TRICUSPID REGURGITATION", 790, 0,"FETAL CARDIAC LESIONS FETAL TRICUSPID REGURGITATION"],
	[799, 3, "REVERSED DUCTUS ARTERIOSUS FLOW", 790, 0,"FETAL CARDIAC LESIONS REVERSED DUCTUS ARTERIOSUS FLOW"],
	[800, 3, "PERICARDOAL EFFUSION", 790, 0,"FETAL CARDIAC LESIONS PERICARDOAL EFFUSION"],
	[801, 2, "THORACIC LESION", 725, 0],
	[802, 3, "BRONCOPULMONARY SEQUESTRATION", 801, 0,"THORACIC LESION BRONCOPULMONARY SEQUESTRATION"],
	[803, 3, "CONGENITAL CYSTIC ADENOMATOID MALFORMATION (CCAM)", 801, 0,"THORACIC LESION CONGENITAL CYSTIC ADENOMATOID MALFORMATION (CCAM) "],
	[804, 3, "CONGENITAL PULMONARY AIRWAY MALFORMATION (CPAM)", 801, 0,"THORACIC LESION CONGENITAL PULMONARY AIRWAY MALFORMATION (CPAM)"],
	[805, 3, "CONGENITAL DIAPHRAGMATIC HERNIA", 801, 0,"THORACIC LESION CONGENITAL DIAPHRAGMATIC HERNIA"],
	[806, 3, "HYDROTHORAX", 801, 0,"THORACIC LESION  HYDROTHORAX"],
	[807, 3, "CHAOS- CONGENITAL HIGH AIRWAY OBSTRUCTION", 801, 0,"THORACIC LESION CHAOS- CONGENITAL HIGH AIRWAY OBSTRUCTION"],
	[808, 3, "FETAL PLEURAL EFFUSION", 801, 0,"THORACIC LESION FETAL PLEURAL EFFUSION"],
	[809, 3, "HYDROPS", 801, 0,"THORACIC LESION HYDROPS"],
	[810, 2, "NEURAL TUBDE DEFECT", 725, 0],
	[811, 3, "MENINGOMYELOCELE", 810, 0,"NEURAL TUBE DEFECT MENINGOMYELOCELE"],
	[812, 3, "MENINGOCELE", 810, 0,"NEURAL TUBE DEFECT MENINGOCELE"],
	[813, 3, "SPINA BIFIDA", 810, 0,"NEURAL TUBE DEFECT SPINA BIFIDA "],
	[814, 3, "SPINA BIFIDA OCCULTA", 810, 0,"NEURAL TUBE DEFECT SPINA BIFIDA OCCULTA"],
	[815, 2, "ABDOMINAL LESION", 725, 0],
	[816, 3, "FETAL CHOLEDOCHAL CYST", 815, 0,"ABDOMINAL LESION FETAL CHOLEDOCHAL CYST"],
	[817, 3, "FETAL HEPATIC CYST", 815, 0,"ABDOMINAL LESION FETAL HEPATIC CYST"],
	[818, 3, "FETAL OVARIAN CYST", 815, 0,"ABDOMINAL LESION FETAL OVARIAN CYST"],
	[819, 3, "FETAL ENTERIC DUPLICATION CYST", 815, 0,"ABDOMINAL LESION FETAL ENTERIC DUPLICATION CYST"],
	[820, 3, "FETAL MECONIUM PSEUDOCYST", 815, 0,"ABDOMINAL LESION FETAL MECONIUM PSEUDOCYST"],
	[821, 3, "FETAL RENAL CYSTS", 815, 0,"ABDOMINAL LESION FETAL RENAL CYSTS"],
	[822, 3, "FETAL URACHAL CYST", 815, 0,"ABDOMINAL LESION FETAL URACHAL CYST"],
	[823, 3, "ASCITES", 815, 0,"ABDOMINAL LESION ASCITES"],
	[824, 2, "GENITO-URINARY LESIONS", 725, 0],
	[825, 3, "PYELECTASIS", 824, 0,"GENITO-URINARY LESIONS PYELECTASIS"],
	[826, 3, "OBSTRUCTIVE UROPATHY", 824, 0,"GENITO-URINARY LESIONS OBSTRUCTIVE UROPATHY"],
	[827, 3, "HYDRONEPHROSIS", 824, 0,"GENITO-URINARY LESIONS HYDRONEPHROSIS"],
	[828, 3, "LUTO- LOWER URINARY TRACT OBSTRUCTION", 824, 0,"GENITO-URINARY LESIONS LUTO- LOWER URINARY TRACT OBSTRUCTION"],
	[829, 3, "POSTERIOR URETHRAL VALVE", 824, 0,"GENITO-URINARY LESIONS POSTERIOR URETHRAL VALVE"],
	[830, 3, "URETHRAL ATRESIA", 824, 0,"GENITO-URINARY LESIONS URETHRAL ATRESIA"],
	[831, 3, "MEGACYSTIS", 824, 0,"GENITO-URINARY LESIONS MEGACYSTIS"],
	[832, 2, "FETAL THERAPY", 725, 0],
	[833, 3, "AMNIOCENTESIS", 832, 0,"FETAL THERAPY AMNIOCENTESIS"],
	[834, 3, "CVS- CHORIONIC VILLUS SAMPLING", 832, 0,"FETAL THERAPY CVS- CHORIONIC VILLUS SAMPLING"],
	[835, 3, "AMNIOREDUCTION", 832, 0,"FETAL THERAPY AMNIOREDUCTION"],
	[836, 3, "BIPOLAR CORD COAGULATION", 832, 0,"FETAL THERAPY BIPOLAR CORD COAGULATION "],
	[837, 3, "CORDOCENTESIS", 832, 0,"FETAL THERAPY CORDOCENTESIS "],
	[838, 3, "FETAL REDUCTION - TRIPLET TO TWINS", 832, 0,"FETAL THERAPY FETAL REDUCTION - TRIPLET TO TWINS"],
	[839, 3, "FETAL REDUCTION - TRIPLET TO SINGLETON", 832, 0,"FETAL THERAPY FETAL REDUCTION - TRIPLET TO SINGLETON"],
	[840, 3, "FETAL REDUCTION - TWINS TO SINGLETON", 832, 0,"FETAL THERAPY FETAL REDUCTION -  TWINS TO SINGLETON"],
	[841, 3, "FETAL REDUCTION-OTHER", 832, 0,"FETAL THERAPY FETAL REDUCTION-OTHER"],
	[842, 3, "FETAL BLOOD SAMPLING", 832, 0,"FETAL THERAPY FETAL BLOOD SAMPLING"],
	[843, 3, "INTRA-UTERINE TRANSFUSION", 832, 0,"FETAL THERAPY INTRA-UTERINE TRANSFUSION "],
	[844, 3, "LASER ABLATION OF ANASTOMOSES", 832, 0,"FETAL THERAPY LASER ABLATION OF ANASTOMOSES "],
	[845, 3, "LASER ABLATION OF CORD", 832, 0,"FETAL THERAPY LASER ABLATION OF CORD "],
	[846, 3, "INTERSTITIAL LASER COAGULATION", 832, 0,"FETAL THERAPY INTERSTITIAL LASER COAGULATION"],
	[847, 3, "RADIO FREQUENCY ABLATION (RFA)", 832, 0,"FETAL THERAPY RADIO FREQUENCY ABLATION (RFA) "],
	[848, 3, "SELECTIVE TERMINATION", 832, 0,"FETAL THERAPY SELECTIVE TERMINATION "],
	[849, 3, "SHUNT INSERTION-VESICOAMNIOTIC", 832, 0,"FETAL THERAPY SHUNT INSERTION-VESICOAMNIOTIC"],
	[850, 3, "SHUNT INSERTION-PLEUROAMNIOTIC", 832, 0,"FETAL THERAPY SHUNT INSERTION-PLEUROAMNIOTIC"],
	[851, 3, "TERMINATION OF PREGNANCY (TOP)", 832, 0,"FETAL THERAPY TERMINATION OF PREGNANCY (TOP) "],
	[852, 3, "PRETERMINATION OF PREGNANCY (TOP) VISIT", 832, 0,"FETAL THERAPY PRETERMINATION OF PREGNANCY (TOP) VISIT"],
	[853, 3, "THORACOCENTESIS", 832, 0,"FETAL THERAPY THORACOCENTESIS "],
	[854, 3, "EXIT PROCEDURE", 832, 0,"FETAL THERAPY EXIT PROCEDURE"],
	[855, 3, "FETOSCOPY", 832, 0,"FETAL THERAPY FETOSCOPY"],
	[856, 3, "FETO- FETOSCOPIC ENDOLUMINAL TRACHEAL OCCLUSION", 832, 0,"FETAL THERAPY FETO- FETOSCOPIC ENDOLUMINAL TRACHEAL OCCLUSION"],
	[857, 3, "OPEN FETAL SURGERY", 832, 0,"FETAL THERAPY OPEN FETAL SURGERY"],
	[858, 3, "FETAL BLOOD SAMPLING", 832, 0,"FETAL THERAPY FETAL BLOOD SAMPLING"],
	[859, 3, "FETAL CARDIAC INTERVENTION", 832, 0,"FETAL THERAPY FETAL CARDIAC INTERVENTION"],
	[860, 3, "FETAL BALLOON VALVULOPLASTY", 832, 0,"FETAL THERAPY FETAL BALLOON VALVULOPLASTY"],
	[861, 3, "FETAL BALLOON VALVULOPLASTY- WITH STENT", 832, 0,"FETAL THERAPY FETAL BALLOON VALVULOPLASTY- WITH STENT"],
	[862, 3, "IN-UTERO STEM CELL TRANSPLANTATION", 832, 0,"FETAL THERAPY IN-UTERO STEM CELL TRANSPLANTATION"],
	[863, 3, "AMNIOTIC BAND RELEASE", 832, 0,"FETAL THERAPY AMNIOTIC BAND RELEASE"],
	[864, 2, "ABNORMAL DOPPLER FLOW", 725, 0],
	[865, 3, "UMBILICAL ARTERY - NORMAL FLOW", 864, 0,"ABNORMAL DOPPLER FLOW UMBILICAL ARTERY - NORMAL FLOW"],
	[866, 3, "UMBILICAL ARTERY - INCREASED DIASTOLOC RESISTANCE", 864, 0,"ABNORMAL DOPPLER FLOW UMBILICAL ARTERY - INCREASED DIASTOLOC RESISTANCE"],
	[867, 3, "UMBILICAL ARTERY - ABSENT DIASTOLIC FLOW", 864, 0,"ABNORMAL DOPPLER FLOW UMBILICAL ARTERY - ABSENT DIASTOLIC FLOW"],
	[868, 3, "UMBILICAL ARTERY - REVERSED DIASTOLIC FLOW", 864, 0,"ABNORMAL DOPPLER FLOW UMBILICAL ARTERY - REVERSED DIASTOLIC FLOW"],
	[869, 3, "MIDDLE CEREBRAL ARTERY - ELEVATED PSV", 864, 0,"ABNORMAL DOPPLER FLOW MIDDLE CEREBRAL ARTERY - ELEVATED PSV"],
	[870, 3, "MIDDLE CEREBRAL ARTERY - REDISTRIBUTION", 864, 0,"ABNORMAL DOPPLER FLOW MIDDLE CEREBRAL ARTERY - REDISTRIBUTION"],
	[871, 3, "DUCTUS VENOSUS DEEP A WAVE", 864, 0,"ABNORMAL DOPPLER FLOW DUCTUS VENOSUS DEEP A WAVE"],
	[872, 3, "DUCTUS VENOSUS DEEP A WAVE REVERSE A WAVE", 864, 0,"ABNORMAL DOPPLER FLOW DUCTUS VENOSUS DEEP A WAVE REVERSE A WAVE"],
	[873, 3, "UTERINE ARTEY INCREASED RESISTANCE", 864, 0,"ABNORMAL DOPPLER FLOW UTERINE ARTEY INCREASED RESISTANCE"],
	[874, 3, "UTERINE ARTEY NOTCH", 864, 0,"ABNORMAL DOPPLER FLOW UTERINE ARTEY NOTCH"],
	[875, 3, "UMBLICAL VEIN VARIX", 864, 0,"ABNORMAL DOPPLER FLOW UMBLICAL VEIN VARIX"],
	[876, 3, "UMBLICAL VEIN VARIX - WITH TURBULENCE", 864, 0,"ABNORMAL DOPPLER FLOW UMBLICAL VEIN VARIX - WITH TURBULENCE"],
	[877, 2, "FETAL TUMORS", 725, 0],
	[878, 3, "FETAL TERATOMA", 877, 0,"FETAL TUMORS FETAL TERATOMA"],
	[879, 3, "FETAL SACROCOCCYGEAL TERATOMA", 877, 0,"FETAL TUMORS FETAL SACROCOCCYGEAL TERATOMA"],
	[880, 3, "FETAL HEMANGIOMA", 877, 0,"FETAL TUMORS FETAL HEMANGIOMA"],
	[881, 3, "FETAL NECK LESION", 877, 0,"FETAL TUMORS FETAL NECK LESION"],
	[882, 3, "FETAL RHABDOMYOMA", 877, 0,"FETAL TUMORS FETAL RHABDOMYOMA"],
	[883, 3, "FETAL LYMPHANGIOMA", 877, 0,"FETAL TUMORS FETAL LYMPHANGIOMA"],
	[884, 3, "FETAL ARTERIO-VENOUS MALFORMATION", 877, 0,"FETAL TUMORS FETAL ARTERIO-VENOUS MALFORMATION"],
	[885, 1, "NEURO", 0, 0],
	[886, 1, "NEURAL", 0, 0],
	[887, 2, "NO ABNORMAL CNS FINDINGS", 886, 0, "NO ABNORMAL CNS FINDINGS"],
	[888, 2, "CMV IN PREGNANCY", 886, 0, "CMV IN PREGNANCY"],
	[889, 2, "BRAIN PARENCHYMA", 886, 0],
	[890, 2, "BRAIN STEM", 886, 0],
	[891, 2, "CORPUS CALLOSUM", 886, 0],
	[892, 2, "CAVUM SEPTI PELLUCIDUM", 886, 0],
	[893, 2, "CAVUM VERGAE", 886, 0],
	[894, 2, "CAVUM VELLI INTERPOSITI", 886, 0],
	[895, 2, "HOLOPROSENCEPHALY", 886, 0],
	[896, 2, "CYSTS", 886, 0],
	[897, 2, "HEAD CIRCUMFERENCE", 886, 0],
	[898, 2, "NEURAL TUBE/SPINE", 886, 0],
	[899, 2, "POSTERIOR FOSSA", 886, 0],
	[900, 2, "VASCULAR", 886, 0],
	[901, 2, "VENTRICLES", 886, 0],
	[902, 3, "ABNORMAL PARENCHYMAL ECHOGENICITY", 889, 0, "BRAIN PARENCHYMA ABNORMAL PARENCHYMAL ECHOGENICITY"],
	[903, 3, "DELAYED GYRATION/SULCATION", 889, 0, "BRAIN PARENCHYMA DELAYED GYRATION/SULCATION"],
	[904, 3, "INTRAPARENCHYMAL BRAIN HEMORRAGE", 889, 0, "BRAIN PARENCHYMA INTRAPARENCHYMAL BRAIN HEMORRAGE"],
	[905, 3, "MALFORMATION OF CORTICAL DEVELOPMENT", 889, 0],
	[906, 3, "X – SPECIFIED IN TEXT – NEURAL AXIS FINDING", 889, 0, "BRAIN PARENCHYMA X – SPECIFIED IN TEXT – NEURAL AXIS FINDING "],
	[907, 4, "ABNORMAL SULCATION", 905, 0, "BRAIN PARENCHYMA MALFORMATION OF CORTICAL DEVELOPMENT ABNORMAL SULCATION"],
	[908, 4, "HEMIMEGALENCEPHALY", 905, 0, "BRAIN PARENCHYMA MALFORMATION OF CORTICAL DEVELOPMENT HEMIMEGALENCEPHALY"],
	[909, 4, "LISSENCEPHALY (AGYRIA / PACHYGYRIA)", 905, 0, "BRAIN PARENCHYMA MALFORMATION OF CORTICAL DEVELOPMENT LISSENCEPHALY (AGYRIA / PACHYGYRIA)"],
	[910, 4, "TUBERS", 905, 0, "BRAIN PARENCHYMA MALFORMATION OF CORTICAL DEVELOPMENT TUBERS"],
	[911, 4, "POLYMICROGYRIA", 905, 0, "BRAIN PARENCHYMA MALFORMATION OF CORTICAL DEVELOPMENT POLYMICROGYRIA"],
	[912, 4, "SCHIZENCEPHALY", 905, 0, "BRAIN PARENCHYMA MALFORMATION OF CORTICAL DEVELOPMENT SCHIZENCEPHALY"],
	[913, 4, "PORENCEPHALIC CYST", 905, 0, "BRAIN PARENCHYMA MALFORMATION OF CORTICAL DEVELOPMENT PORENCEPHALIC CYST"],
	[914, 4, "PERIVENTRICULAR HETEROTOPIA", 905, 0, "BRAIN PARENCHYMA MALFORMATION OF CORTICAL DEVELOPMENT PERIVENTRICULAR HETEROTOPIA"],
	[915, 4, "DISTORTED INTRAHEMISPHERIC FISSURE", 905, 0, "BRAIN PARENCHYMA MALFORMATION OF CORTICAL DEVELOPMENT DISTORTED INTRAHEMISPHERIC FISSURE"],
	[916, 5, "CLOSED LIP", 912, 0, "BRAIN PARENCHYMA MALFORMATION OF CORTICAL DEVELOPMENT SCHIZENCEPHALY CLOSED LIP"],
	[917, 5, "OPEN LIP", 912, 0, "BRAIN PARENCHYMA MALFORMATION OF CORTICAL DEVELOPMENT SCHIZENCEPHALY OPEN LIP"],
	[918, 3, "KINKING OF BRAIN STEM", 890, 0, "BRAIN STEM KINKING OF BRAIN STEM"],
	[919, 3, "MIDBRAIN MALFORMATION", 890, 0, "BRAIN STEM MIDBRAIN MALFORMATION"],
	[920, 3, "HYPOPLASTIC BRAIN STEM", 890, 0, "BRAIN STEM HYPOPLASTIC BRAIN STEM"],
	[921, 3, "PONTINE HYPOPLASIA", 890, 0, "BRAIN STEM PONTINE HYPOPLASIA"],
	[922, 3, "PONTOCEREBELLAR HYPOPLASIA", 890, 0, "BRAIN STEM PONTOCEREBELLAR HYPOPLASIA"],
	[923, 3, "MESENCEPHALOSYNAPSIS", 890, 0, "BRAIN STEM MESENCEPHALOSYNAPSIS"],
	[924, 3, "METENCEPHALOSYNAPSIS", 890, 0, "BRAIN STEM METENCEPHALOSYNAPSIS"],
	[925, 3, "MYELENCEPHALOSYNAPSIS", 890, 0, "BRAIN STEM MYELENCEPHALOSYNAPSIS"],
	[926, 3, "X – SPECIFIED IN TEXT – NEURAL AXIS FINDING", 890, 0, "BRAIN STEM X – SPECIFIED IN TEXT – NEURAL AXIS FINDING"],
	[927, 3, "AGENESIS OF THE CORPUS CALLOSUM", 891, 0, "CORPUS CALLOSUM AGENESIS OF THE CORPUS CALLOSUM"],
	[928, 3, "DYSGENETIC CORPUS CALLOSUM", 891, 0, "CORPUS CALLOSUM DYSGENETIC CORPUS CALLOSUM"],
	[929, 3, "DYSMORPHIC CORPUS CALLOSUM", 891, 0, "CORPUS CALLOSUM DYSMORPHIC CORPUS CALLOSUM"],
	[930, 3, "THICK CORPUS CALLOSUM", 891, 0, "CORPUS CALLOSUM THICK CORPUS CALLOSUM"],
	[931, 3, "SHORT CORPUS CALLOSUM", 891, 0, "CORPUS CALLOSUM SHORT CORPUS CALLOSUM"],
	[932, 3, "LIPOMA OF THE CORPUS CALLOSUM", 891, 0, "CORPUS CALLOSUM LIPOMA OF THE CORPUS CALLOSUM"],
	[933, 3, "X – SPECIFIED IN TEXT – NEURAL AXIS FINDING", 891, 0, "CORPUS CALLOSUM X – SPECIFIED IN TEXT – NEURAL AXIS FINDING"],
	[934, 3, "CSP OBLITERATED", 892, 0, "CAVUM SEPTI PELLUCIDUM CSP OBLITERATED"],
	[935, 3, "CSP DISRUPTED", 892, 0, "CAVUM SEPTI PELLUCIDUM CSP DISRUPTED"],
	[936, 3, "CSP AGENESIS", 892, 0, "CAVUM SEPTI PELLUCIDUM CSP AGENESIS"],
	[937, 3, "CSP ENLARGED", 892, 0, "CAVUM SEPTI PELLUCIDUM CSP ENLARGED"],
	[938, 3, "X – SPECIFIED IN TEXT – NEURAL AXIS FINDING", 892, 0, "CAVUM SEPTI PELLUCIDUM X – SPECIFIED IN TEXT – NEURAL AXIS FINDING"],
	[939, 3, "CV ENLARGED", 893, 0, "CAVUM VERGAE CV ENLARGED"],
	[940, 3, "CV OBLITERATED", 893, 0, "CAVUM VERGAE CV OBLITERATED"],
	[941, 3, "CAVUM VELLI INTERPOSITI CSYT", 894, 0, "CAVUM VELLI INTERPOSITI CAVUM VELLI INTERPOSITI CSYT"],
	[942, 3, "HOLOPROSENCEPHALY ALOBAR", 895, 0, "HOLOPROSENCEPHALY HOLOPROSENCEPHALY ALOBAR"],
	[943, 3, "HOLOPROSENCEPHALY LOBAR", 895, 0, "HOLOPROSENCEPHALY HOLOPROSENCEPHALY LOBAR"],
	[944, 3, "HOLOPROSENCEPHALY SEMILOBAR", 895, 0, "HOLOPROSENCEPHALY HOLOPROSENCEPHALY SEMILOBAR"],
	[945, 3, "HOLOPROSENCEPHALY INTERHEMISPHERIC TYPE SYNTELENCEPHALY", 895, 0, "HOLOPROSENCEPHALY HOLOPROSENCEPHALY INTERHEMISPHERIC TYPE SYNTELENCEPHALY"],
	[946, 3, "HOLOPROSENCEPHALY FUSSED THALAMI", 895, 0, "HOLOPROSENCEPHALY HOLOPROSENCEPHALY FUSSED THALAMI"],
	[947, 3, "ARACHNOID CYST", 896, 0],
	[948, 3, "CHOROID PLEXUS CYSTS", 896, 0, "CYSTS CHOROID PLEXUS CYSTS"],
	[949, 3, "INTRACRANIAL CYST", 896, 0, "CYSTS INTRACRANIAL CYST"],
	[950, 3, "HYDRANENCEPHALY", 896, 0, "CYSTS HYDRANENCEPHALY"],
	[951, 3, "PERIVENTRICULAR PSEUDOCYST - PVPC", 896, 0, "CYSTS PERIVENTRICULAR PSEUDOCYST - PVPC"],
	[952, 3, "PORENCEPHALIC CYST", 896, 0, "CYSTS PORENCEPHALIC CYST"],
	[953, 3, "SCHIZENCEPHALY", 896, 0, "CYSTS SCHIZENCEPHALY"],
	[954, 3, "CAVUM VELLI INTERPOSITI CYST CVI", 896, 0, "CYSTS CAVUM VELLI INTERPOSITI CYST CVI"],
	[955, 3, "X – SPECIFIED IN TEXT – NEURAL AXIS FINDING", 896, 0, "CYSTS X – SPECIFIED IN TEXT – NEURAL AXIS FINDING"],
	[956, 4, "SUPRATENTORIAL", 947, 0, "CYSTS ARACHNOID CYST SUPRATENTORIAL"],
	[957, 4, "INFRATENTORIAL", 947, 0, "CYSTS ARACHNOID CYST INFRATENTORIAL"],
	[958, 3, "LARGE HEAD", 897, 0, "HEAD CIRCUMFERENCE LARGE HEAD"],
	[959, 3, "SMALL HEAD", 897, 0, "HEAD CIRCUMFERENCE SMALL HEAD"],
	[960, 3, "MACROCEPHALY", 897, 0, "HEAD CIRCUMFERENCE MACROCEPHALY"],
	[961, 3, "MICROCEPHALY", 897, 0, "HEAD CIRCUMFERENCE MICROCEPHALY"],
	[962, 3, "X – SPECIFIED IN TEXT – NEURAL AXIS FINDING", 897, 0, "HEAD CIRCUMFERENCE X – SPECIFIED IN TEXT – NEURAL AXIS FINDING"],
	[963, 3, "ARNOLD-CHIARI MALFORMATION", 898, 0, "NEURAL TUBE/SPINE ARNOLD-CHIARI MALFORMATION"],
	[964, 3, "ACRANIA", 898, 0, "NEURAL TUBE/SPINE ACRANIA"],
	[965, 3, "ANENCEPHALY", 898, 0, "NEURAL TUBE/SPINE ANENCEPHALY"],
	[966, 3, "ENCEPHALOCELE", 898, 0, "NEURAL TUBE/SPINE ENCEPHALOCELE"],
	[967, 3, "OPEN SPINAL DYSRAPHISM", 898, 0],
	[968, 3, "CLOSED SPINAL DYSRAPHISM", 898, 0],
	[969, 3, "CAUDAL REGRESSION", 898, 0, "NEURAL TUBE/SPINE CAUDAL REGRESSION"],
	[970, 3, "DIASTEMATOMYELIA", 898, 0, "NEURAL TUBE/SPINE DIASTEMATOMYELIA"],
	[971, 3, "SYRINGOMYELIA", 898, 0, "NEURAL TUBE/SPINE SYRINGOMYELIA"],
	[972, 3, "X – SPECIFIED IN TEXT – NEURAL AXIS FINDING", 898, 0, "NEURAL TUBE/SPINE X – SPECIFIED IN TEXT – NEURAL AXIS FINDING"],
	[973, 4, "HINDBRAIN HERNIATION", 967, 0,"NEURAL TUBE/SPINE OPEN SPINAL DYSRAPHISM  HINDBRAIN HERNIATION"],
	[974, 4, "MENINGOCELE", 967, 0, "NEURAL TUBE/SPINE OPEN SPINAL DYSRAPHISM  MENINGOCELE"],
	[975, 4, "MYELOMENINGOCELE", 967, 0, "NEURAL TUBE/SPINE OPEN SPINAL DYSRAPHISM  MYELOMENINGOCELE"],
	[976, 4, "RACHISCHISIS", 967, 0, "NEURAL TUBE/SPINE OPEN SPINAL DYSRAPHISM  RACHISCHISIS"],
	[977, 4, "INTRADURAL LIPOMA", 968, 0, "NEURAL TUBE/SPINE CLOSED SPINAL DYSRAPHISM  INTRADURAL LIPOMA"],
	[978, 4, "LIMITED DORSAL MYELOSCHISIS", 968, 0, "NEURAL TUBE/SPINE CLOSED SPINAL DYSRAPHISM  LIMITED DORSAL MYELOSCHISIS"],
	[979, 4, "TEHTERED CORD", 968, 0, "NEURAL TUBE/SPINE CLOSED SPINAL DYSRAPHISM  TEHTERED CORD"],
	[980, 4, "DERMAL SINUS", 968, 0, "NEURAL TUBE/SPINE CLOSED SPINAL DYSRAPHISM  DERMAL SINUS"],
	[981, 3, "ARACHNOID CYST", 899, 0, "POSTERIOR FOSSA ARACHNOID CYST"],
	[982, 3, "BLAKE’S POUCH CYST", 899, 0, "POSTERIOR FOSSA BLAKE’S POUCH CYST"],
	[983, 3, "CEREBELLAR HEMORRAGE", 899, 0, "POSTERIOR FOSSA CEREBELLAR HEMORRAGE"],
	[984, 3, "CEREBELLAR HYPOPLASIA", 899, 0, "POSTERIOR FOSSA CEREBELLAR HYPOPLASIA"],
	[985, 3, "CEREBELLAR HYPOPLASIA", 899, 0, "!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!"],
	[986, 3, "DANDY WALKER MALFORMATION", 899, 0, "POSTERIOR FOSSA DANDY WALKER MALFORMATION"],
	[987, 3, "JOUBERT SYNDROME AND RELATED DISORDERS", 899, 0, "POSTERIOR FOSSA JOUBERT SYNDROME AND RELATED DISORDERS"],
	[988, 3, "MEGA CISTERNA MAGNA", 899, 0, "POSTERIOR FOSSA MEGA CISTERNA MAGNA"],
	[989, 3, "PONTOCEREBELLAR HYPOPLASIA", 899, 0, "POSTERIOR FOSSA PONTOCEREBELLAR HYPOPLASIA"],
	[990, 3, "POSTERIOR FOSSA MALFORMATION", 899, 0, "POSTERIOR FOSSA POSTERIOR FOSSA MALFORMATION"],
	[991, 3, "ROMBENCEPHALOSYNAPSIS", 899, 0, "POSTERIOR FOSSA ROMBENCEPHALOSYNAPSIS"],
	[992, 3, "SMALL TCD", 899, 0, "POSTERIOR FOSSA SMALL TCD"],
	[993, 3, "VERMIAN HYPOPLASIA", 899, 0, "POSTERIOR FOSSA VERMIAN HYPOPLASIA"],
	[994, 3, "VERMIAN DYSMORPHISM", 899, 0, "POSTERIOR FOSSA VERMIAN DYSMORPHISM"],
	[995, 3, "VERMIAN AGENESIS/DYSGENESIS", 899, 0, "POSTERIOR FOSSA VERMIAN AGENESIS/DYSGENESIS"],
	[996, 3, "X – SPECIFIED IN TEXT – NEURAL AXIS FINDING", 899, 0, "POSTERIOR FOSSA X – SPECIFIED IN TEXT – NEURAL AXIS FINDING"],
	[997, 3, "SINUS VEIN THROMBOSIS", 900, 0, "VASCULAR SINUS VEIN THROMBOSIS"],
	[998, 3, "MALFORMATION OF CEREBRAL VESSELS", 900, 0, "VASCULAR MALFORMATION OF CEREBRAL VESSELS"],
	[999, 3, "SUBDURAL HEMATOMA", 900, 0, "VASCULAR SUBDURAL HEMATOMA"],
	[1000, 3, "LENTICULOSTRIATAL VASCULOPATHY- LSV", 900, 0, "VASCULAR LENTICULOSTRIATAL VASCULOPATHY- LSV"],
	[1001, 3, "AV MALFORMATION", 900, 0, "VASCULAR AV MALFORMATION"],
	[1002, 3, "VEIN OF GALEN MALFORMATION", 900, 0, "VASCULAR VEIN OF GALEN MALFORMATION"],
	[1003, 3, "DURAL SINUS MALFORMATION", 900, 0, "VASCULAR DURAL SINUS MALFORMATION"],
	[1004, 3, "FALCINE SINUS", 900, 0, "VASCULAR FALCINE SINUS"],
	[1005, 3, "INTRAVENTRICULAR HEMORRAGE", 900, 0, "VASCULAR INTRAVENTRICULAR HEMORRAGE"],
	[1006, 3, "INTRAPARENCHYMAL BRAIN HEMORRAGE", 900, 0, "VASCULAR INTRAPARENCHYMAL BRAIN HEMORRAGE"],
	[1007, 3, "DEVELOPMENTAL VENOUS ANOMALY - DVA", 900, 0, "VASCULAR DEVELOPMENTAL VENOUS ANOMALY - DVA"],
	[1008, 3, "X – SPECIFIED IN TEXT – NEURAL AXIS FINDING", 900, 0, "VASCULAR X – SPECIFIED IN TEXT – NEURAL AXIS FINDING"],
	[1009, 3, "ABNORMAL FOURTH VENTRICLE", 901, 0, "VENTRICLES ABNORMAL FOURTH VENTRICLE"],
	[1010, 3, "AQUEDUCTAL STENOSIS", 901, 0, "VENTRICLES AQUEDUCTAL STENOSIS"],
	[1011, 3, "ASYMMETRIC VENTRICLES", 901, 0, "VENTRICLES ASYMMETRIC VENTRICLES"],
	[1012, 3, "VENTRICULOMEGALY - UNILATERAL", 901, 0, "VENTRICLES VENTRICULOMEGALY - UNILATERAL"],
	[1013, 3, "CHOROID PLEXUS CYSTS", 901, 0, "VENTRICLES CHOROID PLEXUS CYSTS"],
	[1014, 3, "ENLARGED THIRD VENTRICLE", 901, 0, "VENTRICLES ENLARGED THIRD VENTRICLE"],
	[1015, 3, "IRREGULAR WALLS", 901, 0, "VENTRICLES IRREGULAR WALLS"],
	[1016, 3, "VENTRICULOMEGALY - BILATERAL", 901, 0, "VENTRICLES VENTRICULOMEGALY - BILATERAL"],
	[1017, 3, "INTRAVENTRICULAR ADEHISIONS", 901, 0, "VENTRICLES INTRAVENTRICULAR ADEHISIONS"],
	[1018, 3, "X – SPECIFIED IN TEXT – NEURAL AXIS FINDING", 901, 0, "VENTRICLES X – SPECIFIED IN TEXT – NEURAL AXIS FINDING"],
	[1019, 1, "U/S", 0, 0],
	[1020, 2, "QUICK", 1019, 0],
	[1021, 3, "NO ABNORMAL ULTRASOUND FINDINGS", 1020, 0,"NO ABNORMAL ULTRASOUND FINDINGS"],
	[1022, 3, "ULTRASOUND EVALUATION - INTACT", 1020, 0,"ULTRASOUND EVALUATION - INTACT"],
	[1023, 3, "APPROPRIATE FOR GESTATIONAL AGE", 1020, 0,"APPROPRIATE FOR GESTATIONAL AGE"],
	[1024, 3, "LARGE FOR GESTATIONAL AGE", 1020, 0],
	[1025, 3, "SMALL FOR GESTATIONAL AGE", 1020, 0],
	[1026, 3, "INTRAUTERINE GROWTH RETARDATION", 1020, 0,"INTRAUTERINE GROWTH RETARDATION "],
	[1027, 3, "FIRST TRIMESTER EVALUATION", 1020, 0,"FIRST TRIMESTER EVALUATION"],
	[1028, 3, "SECOND TRIMESTER EVALUATION", 1020, 0,"SECOND TRIMESTER EVALUATION"],
	[1029, 3, "THIRD TRIMESTER EVALUATION", 1020, 0,"THIRD TRIMESTER EVALUATION "],
	[1030, 3, "POST PARTUM EVALUATION", 1020, 0,"POST PARTUM EVALUATION"],
	[1031, 4, "OVERGROWTH SYNDROME", 1024, 0,"LARGE FOR GESTATIONAL AGE OVERGROWTH SYNDROME"],
	[1032, 4, "INTRA UTERINE GROWTH RESTRICTION (IUGR)", 1025, 0,"SMALL FOR GESTATIONAL AGE INTRA UTERINE GROWTH RESTRICTION (IUGR)"],
	[1033, 2, "FIRST TRIMESTER EVALUATION", 1019, 0],
	[1034, 3, "ECTOPIC PREGNANCY", 1033, 0],
	[1035, 4, "FALLOPIAN TUBE PREGNANCY", 1034, 0,"ECTOPIC PREGNANCY FALLOPIAN TUBE PREGNANCY"],
	[1036, 4, "NON FALLOPIAN TUBE PREGNANCY", 1034, 0,"ECTOPIC PREGNANCY NON FALLOPIAN TUBE PREGNANCY"],
	[1037, 4, "CERVICAL PREGNANCY", 1034, 0,"ECTOPIC PREGNANCY CERVICAL PREGNANCY"],
	[1038, 4, "CORNUAL PREGNANCY", 1034, 0,"ECTOPIC PREGNANCY CORNUAL PREGNANCY"],
	[1039, 4, "OVARIAN PREGNANCY", 1034, 0,"ECTOPIC PREGNANCY OVARIAN  PREGNANCY"],
	[1040, 4, "CESAREAN SCAR PREGNANCY", 1034, 0,"ECTOPIC PREGNANCY CESAREAN SCAR PREGNANCY"],
	[1041, 4, "SUSPECTED ECTOPIC PREGNANY", 1034, 0,"ECTOPIC PREGNANCY SUSPECTED ECTOPIC PREGNANY "],
	[1042, 4, "X - SPECIFIED IN TEXT - ECTOPIC PREGNANY", 1034, 0,"ECTOPIC PREGNANCY X - SPECIFIED IN TEXT - ECTOPIC PREGNANY"],
	[1043, 3, "PREGNANCY OF UNKNOWN LOCATION", 1033, 0,"PREGNANCY OF UNKNOWN LOCATION"],
	[1044, 3, "INTRA UTERINE PREGNANCY", 1033, 0],
	[1045, 4, "EMBRYO WITH CARDIAC PULSE - INTRA UTERINE", 1044, 0,"INTRA UTERINE PREGNANCY EMBRYO WITH CARDIAC PULSE - INTRA UTERINE"],
	[1046, 4, "GESTATITIONAL SAC -INTRA UTERINE", 1044, 0,"INTRA UTERINE PREGNANCY GESTATITIONAL SAC -INTRA UTERINE"],
	[1047, 3, "NUCHAL TRANSLUCENCY", 1033, 0],
	[1048, 4, "NO ABNORMAL ULTRASOUND FINDINGS", 1047, 0,"NUCHAL TRANSLUCENCY NO ABNORMAL ULTRASOUND FINDINGS"],
	[1049, 4, "ABSENT NASAL BONE", 1047, 0,"NUCHAL TRANSLUCENCY ABSENT NASAL BONE"],
	[1050, 4, "CYSTIC HYGROMA", 1047, 0,"NUCHAL TRANSLUCENCY CYSTIC HYGROMA"],
	[1051, 4, "DUCTUS VENOSUS FLOW - ABNORMAL", 1047, 0,"NUCHAL TRANSLUCENCY DUCTUS VENOSUS FLOW - ABNORMAL"],
	[1052, 4, "ENLARGED NUCHAL TRANSLUCENCY", 1047, 0,"NUCHAL TRANSLUCENCY ENLARGED NUCHAL TRANSLUCENCY"],
	[1053, 4, "MAJOR MALFORMATION", 1047, 0,"NUCHAL TRANSLUCENCY MAJOR MALFORMATION"],
	[1054, 4, "MULTIPLE GESTATION", 1047, 0,"NUCHAL TRANSLUCENCY MULTIPLE GESTATION"],
	[1055, 4, "TRICUSPID REGURGITATION", 1047, 0,"NUCHAL TRANSLUCENCY TRICUSPID REGURGITATION"],
	[1056, 4, "X - SPECIFIED IN TEXT - NUCHAL TRANSLUCENCY FINDING", 1047, 0,"NUCHAL TRANSLUCENCY X - SPECIFIED IN TEXT - NUCHAL TRANSLUCENCY FINDING"],
	[1057, 3, "MAJOR MALFORMATION", 1033, 0],
	[1058, 4, "ACRANIA - EARLY PREGNANCY", 1057, 0,"MAJOR MALFORMATION ACRANIA - EARLY PREGNANCY"],
	[1059, 4, "AMNIOTIC BAND SYNDROME - EARLY PREGNANCY", 1057, 0,"MAJOR MALFORMATION AMNIOTIC BAND SYNDROME - EARLY PREGNANCY"],
	[1060, 4, "ANENCEPHALY - EARLY PREGNANCY", 1057, 0,"MAJOR MALFORMATION ANENCEPHALY - EARLY PREGNANCY"],
	[1061, 4, "BODY STALK ANOMALY", 1057, 0,"MAJOR MALFORMATION BODY STALK ANOMALY"],
	[1062, 4, "CYSTIC HYGROMA - EARLY PREGNANCY", 1057, 0,"MAJOR MALFORMATION CYSTIC HYGROMA - EARLY PREGNANCY"],
	[1063, 4, "HOLOPROSENCEPHALY - EARLY PREGNANCY", 1057, 0,"MAJOR MALFORMATION HOLOPROSENCEPHALY - EARLY PREGNANCY"],
	[1064, 4, "VENTRAL WALL DEFECT - EARLY PREGNANCY", 1057, 0,"MAJOR MALFORMATION VENTRAL WALL DEFECT - EARLY PREGNANCY"],
	[1065, 4, "X - SPECIFIED IN TEXT - EARLY PREGNANCY - MAJOR MALFORMATION", 1057, 0,"MAJOR MALFORMATION X - SPECIFIED IN TEXT - EARLY PREGNANCY - MAJOR MALFORMATION"],
	[1066, 3, "MULTIPLE GESTATION", 1033, 0],
	[1067, 4, "TWINS - BICHORIONIC BIAMNIOTIC", 1066, 0,"MULTIPLE GESTATION TWINS - BICHORIONIC BIAMNIOTIC"],
	[1068, 4, "BICHORIONIC BIAMNIOTIC TWINS DISCORDANCE FOR ABNORMALITY", 1066, 0,"MULTIPLE GESTATION BICHORIONIC BIAMNIOTIC TWINS DISCORDANCE FOR ABNORMALITY"],
	[1069, 4, "BICHORIONIC BIAMNIOTIC TWINS DISCORDANT GROWTH", 1066, 0,"MULTIPLE GESTATION BICHORIONIC BIAMNIOTIC TWINS DISCORDANT GROWTH"],
	[1070, 4, "TWINS - MONOCHORIONIC BIAMNIOTIC", 1066, 0,"MULTIPLE GESTATION TWINS - MONOCHORIONIC BIAMNIOTIC"],
	[1071, 4, "TWINS - MONOCHORIONIC MONOAMNIOTIC", 1066, 0,"MULTIPLE GESTATION TWINS - MONOCHORIONIC MONOAMNIOTIC"],
	[1072, 4, "TRIPLETS", 1066, 0,"MULTIPLE GESTATION TRIPLETS"],
	[1073, 4, "X - SPECIFIED IN TEXT - MULTIPLE GESTATION", 1066, 0,"MULTIPLE GESTATION X - SPECIFIED IN TEXT - MULTIPLE GESTATION"],
	[1074, 3, "ABORTION", 1033, 0],
	[1075, 4, "COMPLETE ABORTION", 1074, 0,"COMPLETE ABORTION"],
	[1076, 4, "INCOMPLETE ABORTION", 1074, 0,"INCOMPLETE ABORTION"],
	[1077, 4, "MISSED ABORTION", 1074, 0,"MISSED ABORTION"],
	[1078, 4, "BLIGHTED OVUM", 1074, 0,"ABORTION BLIGHTED OVUM"],
	[1079, 4, "RETAINED PRODUCTS OF CONCEPTION", 1074, 0,"ABORTION RETAINED PRODUCTS OF CONCEPTION"],
	[1080, 4, "THREATENED ABORTION", 1074, 0,"THREATENED ABORTION"],
	[1081, 3, "GESTATIONAL TROPHOBLASTIC DISEASE", 1033, 0],
	[1082, 4, "COMPLETE HYDATIFORM MOLE", 1081, 0,"GESTATIONAL TROPHOBLASTIC DISEASE COMPLETE HYDATIFORM MOLE"],
	[1083, 4, "INVASIVE MOLE", 1081, 0,"GESTATIONAL TROPHOBLASTIC DISEASE INVASIVE MOLE"],
	[1084, 4, "PARTIAL HYDATIFORM MOLE", 1081, 0,"GESTATIONAL TROPHOBLASTIC DISEASE PARTIAL HYDATIFORM MOLE"],
	[1085, 4, "PLACENTAL SITE TROPHOBLASTIC TUMOR", 1081, 0,"GESTATIONAL TROPHOBLASTIC DISEASE PLACENTAL SITE TROPHOBLASTIC TUMOR"],
	[1086, 4, "X - SPECIFIED IN TEXT - GESTATIONAL TROPHOBLASTIC DISEASE", 1081, 0,"GESTATIONAL TROPHOBLASTIC DISEASE X - SPECIFIED IN TEXT - GESTATIONAL TROPHOBLASTIC DISEASE"],
	[1087, 2, "ANATOMIC FINDING", 1019, 0],
	[1088, 3, "FACE/NECK", 1087, 0],
	[1089, 4, "BINDER PHENOTYPE", 1088, 0,"FACE/NECK BINDER PHENOTYPE"],
	[1090, 4, "CERVICAL CYST", 1088, 0,"FACE/NECK CERVICAL CYST"],
	[1091, 4, "CLEFT LIP", 1088, 0,"FACE/NECK CLEFT LIP"],
	[1092, 4, "CLEFT LIP AND PALATE", 1088, 0,"FACE/NECK CLEFT LIP AND PALATE"],
	[1093, 4, "CLEFT PALATE", 1088, 0,"FACE/NECK CLEFT PALATE"],
	[1094, 4, "CLEFT PALATE-HARD PALATE", 1088, 0,"FACE/NECK CLEFT PALATE-HARD PALATE"],
	[1095, 4, "CLEFT PALATE-SOFT PALATE", 1088, 0,"FACE/NECK CLEFT PALATE-SOFT PALATE"],
	[1096, 4, "DYSMORPHIC FEATURES", 1088, 0,"FACE/NECK DYSMORPHIC FEATURES"],
	[1097, 4, "EAR ANOMALIES", 1088, 0],
	[1098, 5, "ANOTIA/MICROTIA", 1097, 0,"FACE/NECK EAR ANOMALIES ANOTIA/MICROTIA"],
	[1099, 5, "EXTERNAL EAR MALFORMATION", 1097, 0,"FACE/NECK EAR ANOMALIES EXTERNAL EAR MALFORMATION"],
	[1100, 4, "GOITER", 1088, 0,"FACE/NECK GOITER"],
	[1101, 4, "LARYNGEAL ATRESIA", 1088, 0,"FACE/NECK LARYNGEAL ATRESIA"],
	[1102, 4, "MACROGLOSSIA", 1088, 0,"FACE/NECK MACROGLOSSIA"],
	[1103, 4, "MICROGLOSSIA", 1088, 0,"FACE/NECK MICROGLOSSIA"],
	[1104, 4, "MASS / TUMOR - FACE / NECK", 1088, 0,"FACE/NECK MASS / TUMOR - FACE / NECK"],
	[1105, 4, "MICROGNATHIA / RETROGNATHIA", 1088, 0,"FACE/NECK MICROGNATHIA / RETROGNATHIA"],
	[1106, 4, "NASAL BONES - ABSENT / HYPOPLASIA", 1088, 0,"FACE/NECK NASAL BONES - ABSENT / HYPOPLASIA "],
	[1107, 4, "ORAL CAVITY ANOMALIES", 1088, 0],
	[1108, 4, "ORBITAL / OCULAR FINDING", 1088, 0],
	[1109, 5, "RANULA/EPICANTHUS", 1106, 0,"FACE/NECK ORAL CAVITY ANOMALIES RANULA/EPICANTHUS"],
	[1110, 5, "ANOPHTHALMIA", 1108, 0,"FACE/NECK ORBITAL / OCULAR FINDING ANOPHTHALMIA"],
	[1111, 5, "MICROPHTHALMIA", 1108,"FACE/NECK ORBITAL / OCULAR FINDING MICROPHTHALMIA"],
	[1112, 5, "CATARACT", 1108, 0,"FACE/NECK ORBITAL / OCULAR FINDING CATARACT"],
	[1113, 5, "HYPOTELORISM", 1108, 0,"FACE/NECK ORBITAL / OCULAR FINDING HYPOTELORISM"],
	[1114, 4, "PIERRE ROBIN SEQUENCE", 1088, 0],
	[1115, 5, "HYPERTELORISM", 1114, 0,"FACE/NECK PIERRE ROBIN SEQUENCE HYPERTELORISM"],
	[1116, 4, "THYROID - HYPOPLASTIC", 1088, 0,"FACE/NECK THYROID - HYPOPLASTIC"],
	[1117, 4, "TRACHEAL ATRESIA/AGENESIS", 1088, 0,"FACE/NECK TRACHEAL ATRESIA/AGENESIS"],
	[1118, 4, "THYROGLOSSAL CYST", 1088, 0,"FACE/NECK THYROGLOSSAL CYST"],
	[1119, 4, "X - SPECIFIED IN TEXT - FACE/NECK FINDING", 1088, 0,"X - SPECIFIED IN TEXT - FACE/NECK  FINDING"],
	[1120, 4, "EPIDERMOID CYST", 1128, 0,"SKIN AND SUBCUTANEOUS TISSUE EPIDERMOID CYST"],
	[1121, 4, "BRACHYCEPHALY", 1129, 0,"MUSCULOSKELETAL BRACHYCEPHALY"],
	[1122, 4, "DOLICHCEPHALY", 1129, 0,"MUSCULOSKELETAL DOLICHCEPHALY"],
	[1123, 4, "BONE SHAPE ABNORMALITY", 1129, 0,"MUSCULOSKELETAL BONE SHAPE ABNORMALITY"],
	[1124, 4, "CLUBFOOT", 1129, 0,"MUSCULOSKELETAL CLUBFOOT"],
	[1125, 4, "CLUBHAND", 1129, 0,"MUSCULOSKELETAL CLUBHAND"],
	[1126, 4, "CRANIOSYNOSTOSIS", 1129, 0,"MUSCULOSKELETAL CRANIOSYNOSTOSIS"],
	[1127, 4, "FOOT ABNORMALITY", 1129, 0],
	[1128, 3, "SKIN AND SUBCUTANEOUS TISSUE", 1087, 0],
	[1129, 3, "MUSCULOSKELETAL", 1087, 0],
	[1130, 5, "ABSENT", 1127, 0,"MUSCULOSKELETAL FOOT ABNORMALITY ABSENT"],
	[1131, 5, "ADACTYLY", 1127, 0,"MUSCULOSKELETAL FOOT ABNORMALITY ADACTYLY"],
	[1132, 5, "BRACHYDACTYLY", 1127, 0,"MUSCULOSKELETAL FOOT ABNORMALITY BRACHYDACTYLY"],
	[1133, 5, "CLINODACTYLY", 1127, 0,"MUSCULOSKELETAL FOOT ABNORMALITY CLINODACTYLY"],
	[1134, 5, "CLEFT FOOT/TOES", 1127, 0,"MUSCULOSKELETAL FOOT ABNORMALITY CLEFT FOOT/TOES"],
	[1135, 5, "OLIGODACTYLY", 1127, 0,"MUSCULOSKELETAL FOOT ABNORMALITY OLIGODACTYLY"],
	[1136, 5, "OVERLAPPING TOES", 1127, 0,"MUSCULOSKELETAL FOOT ABNORMALITY OVERLAPPING TOES"],
	[1137, 5, "POLYDACTYLY", 1127, 0,"MUSCULOSKELETAL FOOT ABNORMALITY POLYDACTYLY"],
	[1138, 5, "ROCKER-BOTTOM", 1127, 0,"MUSCULOSKELETAL FOOT ABNORMALITY ROCKER-BOTTOM"],
	[1139, 4, "HAND ABNORMALITY", 1129, 0],
	[1140, 5, "ABSENT", 1139, 0,"MUSCULOSKELETAL HAND ABNORMALITY ABSENT"],
	[1141, 5, "ADACTYLY", 1139, 0,"MUSCULOSKELETAL HAND ABNORMALITY ADACTYLY"],
	[1142, 5, "BRACHYDACTYLY", 1139, 0,"MUSCULOSKELETAL HAND ABNORMALITY BRACHYDACTYLY"],
	[1143, 5, "CLINODACTYLY", 1139, 0,"MUSCULOSKELETAL HAND ABNORMALITY CLINODACTYLY"],
	[1144, 5, "CLEFT HAND/FINGER", 1139, 0,"MUSCULOSKELETAL HAND ABNORMALITY CLEFT HAND/FINGER"],
	[1145, 5, "OLIGODACTYLY", 1139, 0,"MUSCULOSKELETAL HAND ABNORMALITY OLIGODACTYLY"],
	[1146, 5, "OVERLAPPING FINGERS", 1139, 0,"MUSCULOSKELETAL HAND ABNORMALITY OVERLAPPING FINGERS"],
	[1147, 4, "HYPOTONIA", 1129, 0],
	[1148, 5, "POLYDACTYLY", 1147, 0,"MUSCULOSKELETAL HYPOTONIA POLYDACTYLY"],
	[1149, 4, "JOINT ABNORMALITY", 1129, 0],
	[1150, 5, "SYNDACTYLY", 1149, 0,"MUSCULOSKELETAL JOINT ABNORMALITY SYNDACTYLY"],
	[1151, 4, "MINERALIZATION OF BONES ABNORMALITY", 1129, 0,"MUSCULOSKELETAL MINERALIZATION OF BONES ABNORMALITY"],
	[1152, 4, "SACRAL AGENESIS", 1129, 0,"MUSCULOSKELETAL SACRAL AGENESIS"],
	[1153, 4, "SHORT LONG BONES", 1129, 0,"MUSCULOSKELETAL SHORT LONG BONES"],
	[1154, 4, "SKELETAL DYSPLASIA", 1129, 0,"MUSCULOSKELETAL SKELETAL DYSPLASIA"],
	[1155, 4, "VERTEBRAL ANOMALY", 1129, 0],
	[1156, 5, "HEMIVERTEBRA", 1155, 0,"MUSCULOSKELETAL VERTEBRAL ANOMALY HEMIVERTEBRA"],
	[1157, 4, "VORMIAN BONE", 1129, 0],
	[1158, 4, "X - SPECIFIED IN TEXT - MUSCULOSKELETAL FINDING", 1129, 0,"MUSCULOSKELETAL X - SPECIFIED IN TEXT - MUSCULOSKELETAL FINDING"],
	[1159, 3, "THORAX", 1087, 0],
	[1160, 3, "HEART", 1087, 0],
	[1161, 4, "AIRWAY OBSTRUCTION", 1159, 0,"THORAX AIRWAY OBSTRUCTION"],
	[1162, 4, "BRONCHOGENIC CYST", 1159, 0,"THORAX BRONCHOGENIC CYST"],
	[1163, 4, "CONGENITAL PULMONARY ADENOMATOID MALFORMATION (CPAM)", 1159, 0,"THORAX CONGENITAL PULMONARY ADENOMATOID MALFORMATION (CPAM)"],
	[1164, 4, "CONGENITAL DIAPHRAGMATIC HERNIA", 1159, 0,"THORAX CONGENITAL DIAPHRAGMATIC HERNIA"],
	[1165, 4, "DIAPHRAGMATIC EVENTRATION", 1159, 0,"THORAX DIAPHRAGMATIC EVENTRATION"],
	[1166, 4, "HYDROTHORAX", 1159, 0,"THORAX HYDROTHORAX"],
	[1167, 4, "PLUERAL EFFUSION", 1159, 0,"THORAX PLUERAL EFFUSION"],
	[1168, 4, "BRONCHOPULMONARY SEQUESTRATION", 1159, 0,"THORAX BRONCHOPULMONARY SEQUESTRATION"],
	[1169, 4, "X - SPECIFIED IN TEXT - THORAX FINDING", 1159, 0,"THORAX X - SPECIFIED IN TEXT - THORAX FINDING"],
	[1170, 4, "VALVULAR ANOMALY-HEART", 1160, 0],
	[1171, 5, "TRICUSPID", 1170, 0],
	[1172, 6, "STENOTIC", 1171, 0,"HEART VALVULAR ANOMALY-HEART TRICUSPID STENOTIC"],
	[1173, 6, "REGURGITATION", 1171, 0,"HEART VALVULAR ANOMALY-HEART TRICUSPID REGURGITATION"],
	[1174, 6, "DYSPLASTIC", 1171, 0,"HEART VALVULAR ANOMALY-HEART TRICUSPID DYSPLASTIC"],
	[1175, 5, "MITRAL", 1170, 0],
	[1176, 6, "STENOTIC", 1175, 0,"HEART VALVULAR ANOMALY-HEART MITRAL STENOTIC"],
	[1177, 6, "REGURGITATION", 1175, 0,"HEART VALVULAR ANOMALY-HEART MITRAL REGURGITATION"],
	[1178, 6, "DYSPLASTIC", 1175, 0,"HEART VALVULAR ANOMALY-HEART MITRAL DYSPLASTIC"],
	[1179, 5, "AORTIC", 1170, 0],
	[1180, 6, "STENOTIC", 1179, 0,"HEART VALVULAR ANOMALY-HEART AORTIC STENOTIC"],
	[1181, 6, "REGURGITATION", 1179, 0,"HEART VALVULAR ANOMALY-HEART AORTIC REGURGITATION"],
	[1182, 6, "DYSPLASTIC", 1179, 0,"HEART VALVULAR ANOMALY-HEART AORTIC DYSPLASTIC"],
	[1183, 5, "PULMONIC", 1170, 0],
	[1184, 6, "STENOTIC", 1183, 0,"HEART VALVULAR ANOMALY-HEART PULMONIC STENOTIC"],
	[1185, 6, "REGURGITATION", 1183, 0,"HEART VALVULAR ANOMALY-HEART PULMONIC REGURGITATION"],
	[1186, 6, "DYSPLASTIC", 1183, 0,"HEART VALVULAR ANOMALY-HEART PULMONIC DYSPLASTIC"],
	[1187, 5, "ABSENT PULMONIC VALVE", 1170, 0,"HEART VALVULAR ANOMALY-HEART ABSENT PULMONIC VALVE ABSENT PULMONIC VALVE"],
	[1188, 5, "BICUSPID AORTIC VALUE", 1170, 0,"HEART VALVULAR ANOMALY-HEART BICUSPID AORTIC VALUE BICUSPID AORTIC VALUE"],
	[1189, 5, "BICUSPID PULOMNIC VALVE", 1170, 0,"HEART VALVULAR ANOMALY-HEART BICUSPID PULOMNIC VALVE BICUSPID PULOMNIC VALVE "],
	[1190, 4, "AORTIC CORACTATION", 1160, 0,"HEART AORTIC CORACTATION"],
	[1191, 4, "AORTIC ARCH ANOMALY", 1160, 0],
	[1192, 5, "DOUBLE AORTIC ARCH", 1191, 0],
	[1193, 6, "LEFT ARCH ATRESIA", 1192, 0,"HEART AORTIC ARCH ANOMALY DOUBLE AORTIC ARCH LEFT ARCH ATRESIA"],
	[1194, 6, "RIGHT DOMINANCE", 1192, 0,"HEART AORTIC ARCH ANOMALY DOUBLE AORTIC ARCH RIGHT DOMINANCE"],
	[1195, 6, "LEFT DOMINANCE", 1192, 0,"HEART AORTIC ARCH ANOMALY DOUBLE AORTIC ARCH LEFT DOMINANCE"],
	[1196, 6, "CODOMINANCE", 1192, 0,"HEART AORTIC ARCH ANOMALY DOUBLE AORTIC ARCH CODOMINANCE"],
	[1197, 6, "INTERAPUTED AORTIC ARCH", 1191, 0,"HEART AORTIC ARCH ANOMALY INTERAPUTED AORTIC ARCH INTERAPUTED AORTIC ARCH"],
	[1198, 5, "ARSA", 1191, 0,"HEART AORTIC ARCH ANOMALY ARSA"],
	[1199, 5, "RIGHT AORTIC ARCH", 1191, 0,"HEART AORTIC ARCH ANOMALY RIGHT AORTIC ARCH"],
	[1200, 5, "RIGHT AORTIC ARCH WITH ALSA", 1191, 0,"HEART AORTIC ARCH ANOMALY RIGHT AORTIC ARCH WITH ALSA"],
	[1201, 5, "RIGHT AORTIC ARCH MIRROR IMAGE", 1191, 0,"HEART AORTIC ARCH ANOMALY RIGHT AORTIC ARCH MIRROR IMAGE"],
	[1202, 5, "RIGHT AORTIC ARCH WITH RIGHT DUCTUS", 1191, 0,"HEART AORTIC ARCH ANOMALY RIGHT AORTIC ARCH WITH RIGHT DUCTUS"],
	[1203, 5, "BOVINE ARCH", 1191, 0,"HEART AORTIC ARCH ANOMALY BOVINE ARCH"],
	[1204, 4, "DUCTUS ARTERIOSIS TORTOISE", 1160, 0,"HEART DUCTUS ARTERIOSIS TORTOISE"],
	[1205, 4, "DUCTUS ARTERIOSIS OBSTRUCTIVE", 1160, 0,"HEART DUCTUS ARTERIOSIS OBSTRUCTIVE"],
	[1206, 4, "DUCTUS ARTERIOSIS AGENESIS", 1160, 0,"HEART DUCTUS ARTERIOSIS AGENESIS"],
	[1207, 4, "FORAMEN OVALE OBSTRUCTIVE", 1160, 0,"HEART FORAMEN OVALE OBSTRUCTIVE"],
	[1208, 4, "FORAMEN OVALE ANURYSM", 1160, 0,"HEART FORAMEN OVALE ANURYSM"],
	[1209, 4, "FETAL ARRYHTHMIA", 1160, 0,"HEART FETAL ARRYHTHMIA"],
	[1210, 4, "VSD", 1160, 0],
	[1211, 5, "MUSCULAR", 1210, 0,"HEART VSD MUSCULAR"],
	[1212, 5, "MEMBRANOUS", 1210, 0,"HEART VSD MEMBRANOUS"],
	[1213, 5, "INLET", 1210, 0,"HEART VSD INLET"],
	[1214, 5, "OUTLET", 1210, 0,"HEART VSD OUTLET"],
	[1215, 5, "SUBPULMONIC", 1210, 0,"HEART VSD SUBPULMONIC"],
	[1216, 5, "SUBAORTIC", 1210, 0,"HEART VSD SUBAORTIC"],
	[1217, 5, "SUPRACRISTAL", 1210, 0,"HEART VSD SUPRACRISTAL"],
	[1218, 4, "ASD", 1160, 0,"HEART ASD"],
	[1219, 4, "ATRIOVENTRICULAR SEPTAL DEFECT - AV CANAL", 1160, 0,"HEART ATRIOVENTRICULAR SEPTAL DEFECT - AV CANAL"],
	[1220, 4, "ECHOGENIC INTRACARDIC FOCUS", 1160, 0],
	[1221, 5, "RIGHT", 1220, 0,"HEART ECHOGENIC INTRACARDIC FOCUS RIGHT"],
	[1222, 5, "LEFT", 1220, 0,"HEART ECHOGENIC INTRACARDIC FOCUS LEFT"],
	[1223, 5, "MULTIPLE", 1220, 0,"HEART ECHOGENIC INTRACARDIC FOCUS MULTIPLE"],
	[1224, 4, "VENTRICLE / ATRIUM ASYMMETRY", 1160, 0,"HEART VENTRICLE / ATRIUM ASYMMETRY   "],
	[1225, 4, "VENTRICULAR HYPERTROPHY", 1160, 0,"HEART VENTRICULAR HYPERTROPHY"],
	[1226, 4, "VENTRICULAR ANURYSM", 1160, 0,"HEART VENTRICULAR ANURYSM"],
	[1227, 4, "SINGLE VENTRICLE", 1160, 0,"HEART SINGLE VENTRICLE"],
	[1228, 4, "HYPOPLASTIC LEFT HEART SYNDROME", 1160, 0,"HEART HYPOPLASTIC LEFT HEART SYNDROME"],
	[1229, 4, "HYPOPLASTIC RIGHT HEART SYNDROME", 1160, 0,"HEART HYPOPLASTIC RIGHT HEART SYNDROME"],
	[1230, 4, "DOUBLE OUTLET RIGHT VENTRICLE", 1160, 0],
	[1231, 5, "FALLOT TYPE", 1230, 0,"HEART DOUBLE OUTLET RIGHT VENTRICLE FALLOT TYPE"],
	[1232, 5, "TRANSPOSITION TYPE", 1230, 0,"HEART DOUBLE OUTLET RIGHT VENTRICLE TRANSPOSITION TYPE"],
	[1233, 5, "TAUSSIG BING", 1230, 0,"HEART DOUBLE OUTLET RIGHT VENTRICLE TAUSSIG BING"],
	[1234, 4, "TETROLOGY OF FALLOT", 1160, 0],
	[1235, 5, "MAJOR AORTAL PULMONARY COLLATERAL ARTERIES - MAPCA", 1234, 0,"HEART TETROLOGY OF FALLOT MAJOR AORTAL PULMONARY COLLATERAL ARTERIES - MAPCA"],
	[1236, 4, "TRANSPOSITION OF GREAT ARTERIES", 1160, 0],
	[1237, 5, "SIMPLE", 1236, 0,"HEART TRANSPOSITION OF GREAT ARTERIES SIMPLE"],
	[1238, 5, "COMPLEX", 1236, 0,"HEART TRANSPOSITION OF GREAT ARTERIES COMPLEX"],
	[1239, 5, "CORRECTED", 1236, 0,"HEART TRANSPOSITION OF GREAT ARTERIES CORRECTED"],
	[1240, 4, "VENTRICULAR INVERSION", 1160, 0,"HEART VENTRICULAR INVERSION"],
	[1241, 4, "TRUNCUS ARTERIOSIS", 1160, 0,"HEART TRUNCUS ARTERIOSIS"],
	[1242, 4, "MALPOSITION", 1160, 0],
	[1243, 5, "DEXTEROCARDIA", 1242, 0,"HEART MALPOSITION DEXTEROCARDIA"],
	[1244, 5, "MESOCARDIA", 1242, 0,"HEART MALPOSITION MESOCARDIA"],
	[1245, 4, "SITUS INVERSUS", 1160, 0,"HEART SITUS INVERSUS"],
	[1246, 4, "SITUS AMBIGUS", 1160, 0,"HEART SITUS AMBIGUS"],
	[1247, 4, "HETEROTAXY", 1160, 0],
	[1248, 5, "LEFT ISOMERISM", 1247, 0,"HEART HETEROTAXY LEFT ISOMERISM"],
	[1249, 5, "RIGHT ISOMERISM", 1247, 0,"HEART HETEROTAXY RIGHT ISOMERISM"],
	[1250, 4, "VENOUS ANOMALY", 1160, 0],
	[1251, 5, "PERSISTANT LEFT SVC WITH AZYGOUS CONTINUATION- PLSVC", 1250, 0,"HEART VENOUS ANOMALY PERSISTANT LEFT SVC WITH AZYGOUS CONTINUATION- PLSVC"],
	[1252, 5, "PERSISTANT LEFT SVC WITH HEMIAZYGOUS CONTINUATION- PLSVC", 1250, 0,"HEART VENOUS ANOMALY PERSISTANT LEFT SVC WITH HEMIAZYGOUS CONTINUATION- PLSVC"],
	[1253, 5, "SVC ENLARGED", 1250, 0,"HEART VENOUS ANOMALY SVC ENLARGED"],
	[1254, 5, "IVC ENLARGED", 1250, 0,"HEART VENOUS ANOMALY IVC ENLARGED"],
	[1255, 5, "ABSENT IVC", 1250, 0,"HEART VENOUS ANOMALY ABSENT IVC"],
	[1256, 5, "ABSENT SVC", 1250, 0,"HEART VENOUS ANOMALY ABSENT SVC"],
	[1257, 5, "DOUBLE IVC", 1250, 0,"HEART VENOUS ANOMALY DOUBLE IVC"],
	[1258, 5, "TOTAL ANOMALOUS PULMONARY VENOUS RETURN-TAPVR", 1250, 0,"HEART VENOUS ANOMALY TOTAL ANOMALOUS PULMONARY VENOUS RETURN-TAPVR  "],
	[1259, 5, "PARTIAL ANOMALOUS PULMONARY VENOUS RETURN-TAPVR", 1250, 0,"HEART VENOUS ANOMALY PARTIAL ANOMALOUS PULMONARY VENOUS RETURN-TAPVR"],
	[1260, 5, "CHIARI NETWORK", 1250, 0,"HEART VENOUS ANOMALY CHIARI NETWORK"],
	[1261, 4, "CORONARY ARTERY FISTULA", 1160, 0,"HEART CORONARY ARTERY FISTULA"],
	[1262, 4, "MASS", 1160, 0],
	[1263, 4, "PERICARDIAL EFFUSION", 1160, 0,"HEART PERICARDIAL EFFUSION"],
	[1264, 4, "X- SPECIFIED IN TEXT - HEART FINDING", 1160, 0,"HEART X- SPECIFIED IN TEXT - HEART FINDING"],
	[1265, 5, "FIBROMA", 1262, 0,"HEART MASS FIBROMA"],
	[1266, 5, "TUBEROSCLEROSIS", 1262, 0,"HEART MASS TUBEROSCLEROSIS"],
	[1267, 3, "ABDOMINAL WALL DEFECT", 1087, 0],
	[1268, 4, "BLADDER EXTROPHY / OEIS COMPLEX", 1267, 0,"ABDOMINAL WALL DEFECT BLADDER EXTROPHY / OEIS COMPLEX"],
	[1269, 4, "BODY STALK ANOMALY", 1267, 0,"ABDOMINAL WALL DEFECT BLADDER EXTROPHY / OEIS COMPLEX"],
	[1270, 4, "GASTROSCHISIS", 1267, 0,"ABDOMINAL WALL DEFECT GASTROSCHISIS"],
	[1271, 4, "OMPHALOCELE", 1267, 0,"ABDOMINAL WALL DEFECT OMPHALOCELE"],
	[1272, 4, "PENTALOGY OF CANTRELL", 1267, 0,"ABDOMINAL WALL DEFECT PENTALOGY OF CANTRELL"],
	[1273, 4, "PERSISTENT CLOACA", 1267, 0,"ABDOMINAL WALL DEFECT PERSISTENT CLOACA"],
	[1274, 4, "UMBILICAL CORD HERNIA", 1267, 0,"ABDOMINAL WALL DEFECT UMBILICAL CORD HERNIA"],
	[1275, 4, "X - SPECIFIED IN TEXT - ABDOMINAL WALL DEFECT", 1267, 0,"ABDOMINAL WALL DEFECT X - SPECIFIED IN TEXT - ABDOMINAL WALL DEFECT"],
	[1276, 3, "GASTROINTESTINAL", 1087, 0],
	[1277, 4, "ANAL ATRESIA", 1276, 0,"GASTROINTESTINAL ANAL ATRESIA"],
	[1278, 4, "BOWEL OBSTRUCTION/DILATED BOWEL LOOPS", 1276, 0,"GASTROINTESTINAL BOWEL OBSTRUCTION/DILATED BOWEL LOOPS"],
	[1279, 4, "CYST- INTRAABDOMINAL", 1276, 0,"GASTROINTESTINAL CYST- INTRAABDOMINAL"],
	[1280, 4, "FETAL CHOLEDOCHAL CYST", 1276, 0,"GASTROINTESTINAL FETAL CHOLEDOCHAL CYST"],
	[1281, 4, "FETAL HEPATIC CYST", 1276, 0,"GASTROINTESTINAL FETAL HEPATIC CYST"],
	[1282, 4, "FETAL OVARIAN CYST", 1276, 0,"GASTROINTESTINAL FETAL OVARIAN CYST"],
	[1283, 4, "FETAL ENTERIC DUPLICATION CYST", 1276, 0,"GASTROINTESTINAL FETAL ENTERIC DUPLICATION CYST"],
	[1284, 4, "FETAL MECONIUM PSEUDOCYST", 1276, 0,"GASTROINTESTINAL FETAL MECONIUM PSEUDOCYST"],
	[1285, 4, "DEUDENAL ATRESIA", 1276, 0,"GASTROINTESTINAL DEUDENAL ATRESIA"],
	[1286, 4, "ESOPHAGEAL ATRESIA/ TRACHEOESOPHAGEAL FISTULA", 1276, 0,"GASTROINTESTINAL ESOPHAGEAL ATRESIA/ TRACHEOESOPHAGEAL FISTULA"],
	[1287, 4, "GALLBLADDER FINDING", 1276, 0,"GASTROINTESTINAL GALLBLADDER FINDING"],
	[1288, 4, "HYPERECHOIC BOWEL", 1276, 0,"GASTROINTESTINAL HYPERECHOIC BOWEL"],
	[1289, 4, "LIVER FINDING", 1276, 0,"GASTROINTESTINAL LIVER FINDING"],
	[1290, 4, "MECONIUM PERITONITIS", 1276, 0,"GASTROINTESTINAL MECONIUM PERITONITIS"],
	[1291, 4, "PANCREAS FINDING", 1276, 0,"GASTROINTESTINAL PANCREAS FINDING"],
	[1292, 4, "PORTAL SYSTEM - EXTRA-HEPATIC PORTO-SYSTEMIC SHUNT", 1276, 0,"GASTROINTESTINAL PORTAL SYSTEM - EXTRA-HEPATIC PORTO-SYSTEMIC SHUNT"],
	[1293, 4, "PORTAL SYSTEM - INTRA-HEPATIC PORTO-SYSTEMIC SHUNT", 1276, 0,"GASTROINTESTINAL PORTAL SYSTEM - INTRA-HEPATIC PORTO-SYSTEMIC SHUNT"],
	[1294, 4, "PORTAL SYSTEM FINDING", 1276, 0,"GASTROINTESTINAL PORTAL SYSTEM FINDING"],
	[1295, 4, "PRUV", 1276, 0,"GASTROINTESTINAL PRUV"],
	[1296, 4, "VASCULAR VARIATION", 1276, 0,"GASTROINTESTINAL VASCULAR VARIATION"],
	[1297, 4, "SPLEEN FINDING", 1276, 0,"GASTROINTESTINAL SPLEEN FINDING"],
	[1298, 4, "STOMACH", 1276, 0],
	[1299, 4, "URACHAL CYST", 1276, 0,"GASTROINTESTINAL URACHAL CYST"],
	[1300, 4, "BOWEL PERFORATION", 1276, 0,"GASTROINTESTINAL BOWEL PERFORATION"],
	[1301, 4, "ACSITES", 1276, 0,"GASTROINTESTINAL ACSITES"],
	[1302, 4, "X - SPECIFIED IN TEXT - GASTROINTESTINAL FINDING", 1276, 0,"GASTROINTESTINAL X - SPECIFIED IN TEXT - GASTROINTESTINAL FINDING"],
	[1303, 5, "ENLARGED", 1298, 0,"GASTROINTESTINAL STOMACH ENLARGED"],
	[1304, 5, "NON VISUALIZED", 1298, 0,"GASTROINTESTINAL STOMACH NON VISUALIZED"],
	[1305, 5, "SMALL", 1298, 0,"GASTROINTESTINAL STOMACH SMALL"],
	[1306, 3, "GENITOURINARY TRACT FINDING", 1087, 0],
	[1307, 4, "ADRENAL FINDING", 1306, 0,"GENITOURINARY TRACT FINDING ADRENAL FINDING"],
	[1308, 4, "BLADDER ANOMALY", 1306, 0,"GENITOURINARY TRACT FINDING  BLADDER ANOMALY"],
	[1309, 4, "MEGACYSTITIS/ENLARGED BLADDER", 1306, 0,"GENITOURINARY TRACT FINDING MEGACYSTITIS/ENLARGED BLADDER"],
	[1310, 4, "ECHOGENIC KIDNEY", 1306, 0,"GENITOURINARY TRACT FINDING ECHOGENIC KIDNEY"],
	[1311, 4, "ECTOPIC KIDNEY", 1306, 0,"GENITOURINARY TRACT FINDING ECTOPIC KIDNEY"],
	[1312, 4, "GENITAL ANOMALY", 1306, 0,"GENITOURINARY TRACT FINDING GENITAL ANOMALY"],
	[1313, 4, "HORSESHOE KIDNEY", 1306, 0,"GENITOURINARY TRACT FINDING HORSESHOE KIDNEY"],
	[1314, 4, "HYDRONEPHROSIS", 1306, 0,"GENITOURINARY TRACT FINDING HYDRONEPHROSIS"],
	[1315, 4, "HYDROURETER", 1306, 0,"GENITOURINARY TRACT FINDING HYDROURETER"],
	[1316, 4, "PYELECTASIS", 1306, 0,"GENITOURINARY TRACT FINDING PYELECTASIS"],
	[1317, 4, "HYPOSPADIAS", 1306, 0,"GENITOURINARY TRACT FINDING HYPOSPADIAS"],
	[1318, 4, "LARGE KIDNEY", 1306, 0,"GENITOURINARY TRACT FINDING LARGE KIDNEY"],
	[1319, 4, "LOWER URINARY TRACT OBSTRUCTION", 1306, 0,"GENITOURINARY TRACT FINDING LOWER URINARY TRACT OBSTRUCTION"],
	[1320,0,"",0,0 ],
	[1321,0,"",0,0 ],
	[1322, 4, "MULTICYSTIC DYSPLASTIC KIDNEY - MCDK", 1306, 0,"GENITOURINARY TRACT FINDING MULTICYSTIC DYSPLASTIC KIDNEY - MCDK"],
	[1323, 4, "POLYCYSTIC KIDNEY", 1306, 0,"GENITOURINARY TRACT FINDING POLYCYSTIC KIDNEY"],
	[1324, 4, "PELVIC KIDNEY", 1306, 0,"GENITOURINARY TRACT FINDING PELVIC KIDNEY"],
	[1325, 4, "POTTER SEQUENCE", 1306, 0,"GENITOURINARY TRACT FINDING POTTER SEQUENCE"],
	[1326, 4, "RENAL AGENESIS", 1306, 0,"GENITOURINARY TRACT FINDING RENAL AGENESIS"],
	[1327, 4, "SMALL KIDNEY", 1306, 0,"GENITOURINARY TRACT FINDING SMALL KIDNEY"],
	[1328, 4, "FETAL RENAL CYSTS", 1306, 0,"GENITOURINARY TRACT FINDING FETAL RENAL CYSTS"],
	[1329, 4, "FETAL URACHAL CYST", 1306, 0,"GENITOURINARY TRACT FINDING FETAL URACHAL CYST"],
	[1330, 4, "X - SPECIFIED IN TEXT - GENITOURINARY TRACT FINDING", 1306, 0,"GENITOURINARY TRACT FINDING X - SPECIFIED IN TEXT - GENITOURINARY TRACT FINDING"],
	[1331, 3, "SOFT MARKERS", 1087, 0],
	[1332, 4, "ARSA", 1331, 0,"SOFT MARKERS ARSA"],
	[1333, 4, "CHOROID PLEXUS CYST", 1331, 0,"SOFT MARKERS CHOROID PLEXUS CYST"],
	[1334, 4, "ECOGENIC BOWEL", 1331, 0,"SOFT MARKERS ECOGENIC BOWEL"],
	[1335, 4, "INTRACARDIAC ECHOGENIC FOCUS", 1331, 0,"SOFT MARKERS INTRACARDIAC ECHOGENIC FOCUS"],
	[1336, 4, "PYELECTASIS", 1331, 0,"SOFT MARKERS PYELECTASIS"],
	[1337, 4, "SANDAL GAP", 1331, 0,"SOFT MARKERS SANDAL GAP"],
	[1338, 4, "SHORT FEMUR/HUMERUS", 1331, 0,"SOFT MARKERS SHORT FEMUR/HUMERUS"],
	[1339, 2, "OBSTETRICAL FINDINGS", 1019, 0],
	[1340, 3, "INTRA UTERINE FETAL DEATH - IUFD", 1339, 0,"INTRA UTERINE FETAL DEATH - IUFD"],
	[1341, 3, "AMNIOTIC", 1339, 0],
	[1342, 4, "AMNIOTIC BAND", 1341, 0,"AMNIOTIC BAND"],
	[1343, 4, "AMNIOTIC SHEET", 1341, 0,"AMNIOTIC SHEET"],
	[1344, 4, "OLIGOHYDRAMNIOS", 1341, 0,"AMNIOTIC OLIGOHYDRAMNIOS"],
	[1345, 4, "POLYHYDRAMNIOS", 1341, 0,"AMNIOTIC POLYHYDRAMNIOS"],
	[1346, 4, "X - SPECIFIED IN TEXT - AMNIOTIC FINDING", 1341, 0,"AMNIOTIC X - SPECIFIED IN TEXT - AMNIOTIC FINDING"],
	[1347, 3, "CERVICAL", 1339, 0],
	[1348, 4, "CERCLAGE", 1347, 0,"CERVICAL CERCLAGE"],
	[1349, 4, "FUNNELING", 1347, 0,"CERVICAL FUNNELING"],
	[1350, 4, "SHORTENING", 1347, 0,"CERVICAL SHORTENING"],
	[1351, 4, "X - SPECIFIED IN TEXT - CERVICAL FINDING", 1347, 0,"CERVICAL X - SPECIFIED IN TEXT - CERVICAL FINDING"],
	[1352, 3, "DOPPLER", 1339, 0],
	[1353, 4, "CEREBRO PLACENTAL RATIO (CPR) -ABNORMAL", 1352, 0,"DOPPLER CEREBRO PLACENTAL RATIO (CPR) -ABNORMAL"],
	[1354, 4, "DUCTUS VENOSUS FLOW - ABNORMAL", 1352, 0,"DOPPLER DUCTUS VENOSUS FLOW - ABNORMAL"],
	[1355, 4, "MIDDLE CEREBRAL ARTERY FLOW - ABNORMAL", 1352, 0,"DOPPLER MIDDLE CEREBRAL ARTERY FLOW - ABNORMAL"],
	[1356, 4, "UMBILICAL ARTERY FLOW - ABNORMAL", 1352, 0,"DOPPLER UMBILICAL ARTERY FLOW - ABNORMAL"],
	[1357, 4, "UTERINE ARTERY FLOW - ABNORMAL", 1352, 0,"DOPPLER UTERINE ARTERY FLOW - ABNORMAL"],
	[1358, 4, "X - SPECIFIED IN TEXT - DOPPLER FINDING", 1352, 0,"DOPPLER X - SPECIFIED IN TEXT - DOPPLER FINDING"],
	[1359, 3, "HYDROPS FETALIS", 1339, 0,"HYDROPS FETALIS"],
	[1360, 3, "PLACENTA", 1339, 0],
	[1361, 4, "ABRUPTION", 1360, 0,"PLACENTA ABRUPTION"],
	[1362, 4, "ACCRETA / INCRETA / PERCRETA", 1360, 0,"PLACENTA ACCRETA / INCRETA / PERCRETA"],
	[1363, 4, "ACCRETA", 1360, 0,"PLACENTA ACCRETA"],
	[1364, 4, "INCRETA", 1360, 0,"PLACENTA INCRETA"],
	[1365, 4, "PERCRETA", 1360, 0,"PLACENTA PERCRETA"],
	[1366, 4, "BILOBATA", 1360, 0,"PLACENTA BILOBATA"],
	[1367, 4, "CHORIOANGIOMA", 1360, 0,"PLACENTA CHORIOANGIOMA"],
	[1368, 4, "HEMATOMA - SUBCHORIAL", 1360, 0,"PLACENTA HEMATOMA - SUBCHORIAL"],
	[1369, 4, "HEMATOMA - RETROPLACENTAL", 1360, 0,"PLACENTA HEMATOMA - RETROPLACENTAL"],
	[1370, 4, "LOW LYING PLACENTA", 1360, 0,"PLACENTA LOW LYING  PLACENTA"],
	[1371, 4, "PLACENTA PREVIA - COMPLETE", 1360, 0,"PLACENTA PLACENTA PREVIA - COMPLETE"],
	[1372, 4, "PLACENTA PREVIA - MARGINAL", 1360, 0,"PLACENTA PLACENTA PREVIA - MARGINAL"],
	[1373, 4, "SUCCENTURIATE (ACCESORY) LOBE", 1360, 0,"PLACENTA SUCCENTURIATE (ACCESORY) LOBE"],
	[1374, 4, "X - SPECIFIED IN TEXT - PLACENTA FINDING", 1360, 0,"PLACENTA X - SPECIFIED IN TEXT -  PLACENTA FINDING"],
	[1375, 3, "UMBILICAL CORD", 1339, 0],
	[1376, 4, "NUCHAL CORD", 1375, 0,"UMBILICAL CORD NUCHAL CORD"],
	[1377, 4, "SINGLE UMBILICAL ARTERY", 1375, 0,"UMBILICAL CORD SINGLE UMBILICAL ARTERY"],
	[1378, 4, "UMBILICAL CORD CYST", 1375, 0,"UMBILICAL CORD UMBILICAL CORD CYST"],
	[1379, 4, "UMBILICAL VARIX", 1375, 0,"UMBILICAL CORD UMBILICAL VARIX"],
	[1380, 4, "VASA PREVIA", 1375, 0,"UMBILICAL CORD VASA PREVIA "],
	[1381, 4, "VELAMENTOUS VESSELS", 1375, 0,"UMBILICAL CORD VELAMENTOUS VESSELS"],
	[1382, 4, "VELAMENTOUS INSERTION OF CORD", 1375, 0,"UMBILICAL CORD VELAMENTOUS INSERTION OF CORD"],
	[1383, 4, "KNOT", 1375, 0,"UMBILICAL CORD KNOT"],
	[1384, 4, "X - SPECIFIED IN TEXT - UMBILICAL CORD FINDING", 1375, 0,"UMBILICAL CORD X - SPECIFIED IN TEXT -  UMBILICAL CORD FINDING"],
	[1385, 3, "UTERUS", 1339, 0],
	[1386, 4, "SCAR DEHISCENCE", 1385, 0,"UTEROUS SCAR DEHISCENCE"],
	[1387, 4, "SCAR RUPTURE", 1385, 0,"UTEROUS SCAR RUPTURE"],
	[1388, 4, "THIN LOW SEGMENT", 1385, 0,"UTEROUS THIN LOW SEGMENT"],
	[1389, 2, "POST PARTUM", 1019, 0],
	[1390, 2, "GENETICS", 1019, 0],
	[1391, 3, "BLOOD CLOTS - UTERINE", 1389, 0,"BLOOD CLOTS - UTERINE"],
	[1392, 3, "OVARIAN VEIN THROMBOSIS", 1389, 0,"OVARIAN VEIN THROMBOSIS"],
	[1393, 3, "RETAINED PLACENTA", 1389, 0,"RETAINED PLACENTA"],
	[1394, 3, "RETAINED PRODUCTS OF CONCEPTION", 1389, 0,"RETAINED PRODUCTS OF CONCEPTION"],
	[1395, 3, "SUBFASCIAL HEMATOMA", 1389, 0,"SUBFASCIAL HEMATOMA"],
	[1396, 3, "X - SPECIFIED IN TEXT - POST PARTUM FINDING", 1389, 0,"X - SPECIFIED IN TEXT - POST PARTUM FINDING"],
	[1397, 3, "ABNORMAL FINDING IN FETAL EXOME", 1390, 0,"ABNORMAL FINDING IN FETAL EXOME"],
	[1398, 3, "ABNORMAL FINDING IN FETAL CMA", 1390, 0,"ABNORMAL FINDING IN FETAL CMA"],
	[1399, 3, "ABNORMAL FINDING IN FETAL KARYOTYPE", 1390, 0,"ABNORMAL FINDING IN FETAL KARYOTYPE"],
	[1400, 3, "ABNORMAL FINDING IN PARENTAL EXOME", 1390, 0,"ABNORMAL FINDING IN PARENTAL EXOME"],
	[1401, 3, "ABNORMAL FINDING IN MATERNAL EXOME", 1390, 0,"ABNORMAL FINDING IN MATERNAL EXOME"],
	[1402, 3, "ABNORMAL FINDING IN MATERNAL CMA", 1390, 0,"ABNORMAL FINDING IN MATERNAL CMA"],
	[1403, 3, "ABNORMAL FINDING IN PATERNAL CMA", 1390, 0,"ABNORMAL FINDING IN PATERNAL CMA"],
	[1404, 3, "INHERITED CHANGE IN KARYOTYPE", 1390, 0,"INHERITED CHANGE IN KARYOTYPE"],
	[1405, 3, "A GENETIC SYNDROME IN THE FAMILY", 1390, 0,"A GENETIC SYNDROME IN THE FAMILY"],
	[1406, 3, "INHERITED CHANGE IN CMA", 1390, 0,"INHERITED CHANGE IN CMA"],
	[1407, 3, "INHERITED CHANGE IN EXOME", 1390, 0,"INHERITED CHANGE IN EXOME"],
	[1408, 1, "UTERUS", 1496, 1],
	[1409, 2, "ADENOMYOSIS", 1408, 1,"UTERUS ADENOMYOSIS"],
	[1410, 2, "FIBROID/S-COMPLEX", 1408, 1,"UTERUS FIBROID/S-COMPLEX"],
	[1411, 2, "FIBROID/S-INTRAMURAL", 1408, 1,"UTERUS FIBROID/S-INTRAMURAL"],
	[1412, 2, "FIBROIDS-MULTIPLE", 1408, 1,"UTERUS FIBROIDS-MULTIPLE"],
	[1413, 2, "FIBROIDS-SUBSEROSAL", 1408, 1,"UTERUS FIBROIDS-SUBSEROSAL"],
	[1414, 2, "FIBROIDS-SUBMUCOSAL", 1408, 1,"UTERUS FIBROIDS-SUBMUCOSAL"],
	[1415, 2, "FIBROIDS-TRANSMURAL", 1408, 1,"UTERUS FIBROIDS-TRANSMURAL"],
	[1416, 2, "FIBROIDS-PEDUNCULATED", 1408, 1,"UTERUS FIBROIDS-PEDUNCULATED"],
	[1417, 2, "CORPUS UTERI - MALIGNANT MIXED MESODERMAL (MULLERIAN) TUMOR", 1408, 1,"UTERUS CORPUS UTERI - MALIGNANT MIXED MESODERMAL (MULLERIAN) TUMOR"],
	[1418, 2, "CORPUS UTERI - SARCOMA", 1408, 1,"UTERUS CORPUS UTERI - SARCOMA"],
	[1419, 2, "POLYP", 1408, 1,"UTERUS POLYP"],
	[1420, 2, "ARCUATE", 1408, 1,"UTERUS ARCUATE"],
	[1421, 2, "SEPTATED", 1408, 1,"UTERUS SEPTATED"],
	[1422, 2, "BICORNUATE", 1408, 1,"UTERUS BICORNUATE"],
	[1423, 2, "MULLERIAN ANOMALY", 1408, 1,"UTERUS MULLERIAN ANOMALY"],
	[1424, 2, "INTRAUTERINE DEVICE", 1408, 1,"UTERUS INTRAUTERINE DEVICE"],
	[1425, 2, "NICHE", 1408, 1,"UTERUS NICHE"],
	[1426, 2, "S/P HYSTERECTOMY", 1408, 1,"UTERUS S/P HYSTERECTOMY"],
	[1427, 2, "CYST CERVICAL", 1408, 1,"UTERUS CYST CERVICAL"],
	[1428, 2, "CERVICAL CARCINOMA", 1408, 1,"UTERUS CERVICAL CARCINOMA"],
	[1429, 2, "CERVICAL MASS", 1408, 1,"UTERUS CERVICAL MASS"],
	[1430, 2, "HEMATOCOLPOS", 1408, 1,"UTERUS HEMATOCOLPOS"],
	[1431, 2, "HEMATOMETRA", 1408, 1,"UTERUS HEMATOMETRA"],
	[1432, 2, "X-SPECIFIED IN TEXT - UTERINE FINDING", 1408, 1,"UTERUS X-SPECIFIED IN TEXT - UTERINE FINDING"],
	[1433, 1, "ENDOMETRIUM", 1496, 1],
	[1434, 2, "IRREGULAR", 1433, 1,"ENDOMETRIUM IRREGULAR"],
	[1435, 2, "THICK LAYER", 1433, 1,"ENDOMETRIUM THICK LAYER"],
	[1436, 2, "THIN LAYER", 1433, 1,"ENDOMETRIUM THIN LAYER"],
	[1437, 2, "FLUID", 1433, 1,"ENDOMETRIUM FLUID"],
	[1438, 2, "HYPERPLASIA", 1433, 1,"ENDOMETRIUM HYPERPLASIA"],
	[1439, 2, "POLYPS", 1433, 1,"ENDOMETRIUM POLYPS"],
	[1440, 2, "POSTMENSTURAL PHASE", 1433, 1,"ENDOMETRIUM POSTMENSTURAL PHASE"],
	[1441, 2, "PROLIFERATIVE PHASE", 1433, 1,"ENDOMETRIUM PROLIFERATIVE PHASE"],
	[1442, 2, "SECRETORY PHASE", 1433, 1,"ENDOMETRIUM SECRETORY PHASE"],
	[1443, 2, "ENDOMETRIOD CARCINOMA", 1433, 1,"ENDOMETRIUM ENDOMETRIOD CARCINOMA"],
	[1444, 2, "X-SPECIFIED IN TEXT - ENDOMETRIAL FINDING", 1433, 1,"ENDOMETRIUM X-SPECIFIED IN TEXT - ENDOMETRIAL FINDING"],
	[1445, 1, "OVARY", 1496, 1],
	[1446, 2, "CORPUS LUTEUM", 1445, 1,"OVARY CORPUS LUTEUM"],
	[1447, 2, "CORPUS LUTEUM- HEMORRHAGIC", 1445, 1,"OVARY CORPUS LUTEUM- HEMORRHAGIC"],
	[1448, 2, "CYST", 1445, 1,"OVARY CYST"],
	[1449, 2, "CYST-MULTIPLE", 1445, 1,"OVARY CYST-MULTIPLE"],
	[1450, 2, "CYST-SEPTATED", 1445, 1,"OVARY CYST-SEPTATED"],
	[1451, 2, "CYST-SOLID", 1445, 1,"OVARY CYST-SOLID"],
	[1452, 2, "CYST-SIMPLE", 1445, 1,"OVARY CYST-SIMPLE"],
	[1453, 2, "DERMOID CYST", 1445, 1,"OVARY DERMOID CYST"],
	[1454, 2, "ENDOMETRIOMA", 1445, 1,"OVARY ENDOMETRIOMA"],
	[1455, 2, "FOLLICULE ASSESMENT", 1445, 1,"OVARY FOLLICULE ASSESMENT"],
	[1456, 2, "OVARIAN HYPERSTIMULATION", 1445, 1,"OVARY OVARIAN HYPERSTIMULATION"],
	[1457, 2, "MENOPAUSE", 1445, 1,"OVARY MENOPAUSE"],
	[1458, 2, "PARAOVARIAN CYST", 1445, 1,"OVARY PARAOVARIAN CYST"],
	[1459, 2, "POLYCYSTIC OVARY", 1445, 1,"OVARY POLYCYSTIC OVARY"],
	[1460, 2, "TORSION-OVARY", 1445, 1,"OVARY TORSION-OVARY"],
	[1461, 2, "TUBO OBARIAN ABCESS", 1445, 1,"OVARY TUBO OBARIAN ABCESS"],
	[1462, 2, "S/P SALPINGO OOPHORECTOMY - UNILATERAL", 1445, 1,"OVARY S/P SALPINGO OOPHORECTOMY - UNILATERAL"],
	[1463, 2, "S/P SALPINGO OOPHORECTOMY - BILATERAL", 1445, 1,"OVARY S/P SALPINGO OOPHORECTOMY - BILATERAL"],
	[1464, 2, "S/P OOPHORECTOMY - UNILATERAL", 1445, 1,"OVARY S/P OOPHORECTOMY - UNILATERAL"],
	[1465, 2, "S/P OOPHORECTOMY - BILATERAL", 1445, 1,"OVARY S/P OOPHORECTOMY - BILATERAL"],
	[1466, 2, "X-SPECIFIED IN TEXT - OVARIAN FINDING", 1445, 1,"OVARY X-SPECIFIED IN TEXT - OVARIAN FINDING"],
	[1467, 1, "FALLOPIAN TUBE", 1496, 1],
	[1468, 2, "TORSION-FALLOPIAN TUBE", 1467, 1,"FALLOPIAN TUBE TORSION-FALLOPIAN TUBE"],
	[1469, 2, "HYDROSALPINX", 1467, 1,"FALLOPIAN TUBE HYDROSALPINX"],
	[1470, 2, "SACTOSALPINX", 1467, 1,"FALLOPIAN TUBE SACTOSALPINX"],
	[1471, 2, "HEMATOSALPINX", 1467, 1,"FALLOPIAN TUBE HEMATOSALPINX"],
	[1472, 2, "OCCLUSION OF FALLOPIAN TUBES - UNILATERAL", 1467, 1,"FALLOPIAN TUBE OCCLUSION OF FALLOPIAN TUBES - UNILATERAL"],
	[1473, 2, "OCCLUSION OF FALLOPIAN TUBES - BILATERAL", 1467, 1,"FALLOPIAN TUBE OCCLUSION OF FALLOPIAN TUBES - BILATERAL"],
	[1474, 2, "MASS", 1467, 1,"FALLOPIAN TUBE MASS"],
	[1475, 2, "S/P SALPINGECTOMY - UNILATERAL", 1467, 1,"FALLOPIAN TUBE S/P SALPINGECTOMY - UNILATERAL"],
	[1476, 2, "S/P SALPINGECTOMY - BILATERAL", 1467, 1,"FALLOPIAN TUBE S/P SALPINGECTOMY - BILATERAL"],
	[1477, 2, "X-SPECIFIED IN TEXT - FALLOPIAN TUBE FINDING", 1467, 1,"FALLOPIAN TUBE X-SPECIFIED IN TEXT - FALLOPIAN TUBE FINDING"],
	[1478, 2, "PELVIC FLUID", 1509, 1,"PELVIC FLUID"],
	[1479, 2, "HEMOPERITONEUM", 1509, 1,"PELVIC HEMOPERITONEUM"],
	[1480, 2, "PELVIC ADHESIONS", 1509, 1,"PELVIC ADHESIONS"],
	[1481, 2, "ENDOMETRIOSIS", 1509, 1,"PELVIC ENDOMETRIOSIS"],
	[1482, 2, "ENDOMETRIOMA", 1509, 1,"PELVIC ENDOMETRIOMA"],
	[1483, 2, "ENDOMETRIOSIS ON BOWL", 1509, 1,"PELVIC ENDOMETRIOSIS ON BOWL"],
	[1484, 2, "ENDOMETRIOSIS -GU SYSTEM", 1509, 1,"PELVIC ENDOMETRIOSIS -GU SYSTEM"],
	[1485, 2, "ENDOMETRIOSIS IN SCAR OF SKIN", 1509, 1,"PELVIC ENDOMETRIOSIS IN SCAR OF SKIN"],
	[1486, 2, "ENDOMETRIOSIS OF RECTOVAGINAL SEPTUM AND VAGINA", 1509, 1,"PELVIC ENDOMETRIOSIS OF RECTOVAGINAL SEPTUM AND VAGINA"],
	[1487, 2, "PELVIC MASS", 1509, 1,"PELVIC MASS"],
	[1488, 2, "X-SPECIFIED IN TEXT - PELVIC FINDING", 1509, 1,"PELVIC FINDING X-SPECIFIED IN TEXT"],
	[1489, 1, "NON GYNECOLOGIC FINDING", 1496, 1],
	[1490, 2, "APPENDIX FINDING", 1489, 1,"NON GYNECOLOGIC FINDING APPENDIX FINDING"],
	[1491, 2, "BLADDER FINDING", 1489, 1,"NON GYNECOLOGIC FINDING BLADDER FINDING"],
	[1492, 2, "HYDRONEPHROSIS", 1489, 1,"NON GYNECOLOGIC FINDING HYDRONEPHROSIS"],
	[1493, 2, "HYDROURETER", 1489, 1,"NON GYNECOLOGIC FINDING HYDROURETER"],
	[1494, 2, "URINARY TRACT OBSTRUCTION", 1489, 1,"NON GYNECOLOGIC FINDING URINARY TRACT OBSTRUCTION"],
	[1495, 2, "X-SPECIFIED IN TEXT - NON GYNECOLOGICAL FINDING", 1489, 1,"X-SPECIFIED IN TEXT - NON GYNECOLOGICAL FINDING"],
	[1496,1,"Gynaecology",0,0],
    [1497,3,"Monochorionic twins",726,0,"Monochorionic twins"],
    [1498,3,"TRIPLET PREGNANCY",754,0,"TRIPLET PREGNANCY"],
    [1499,3,"CMV IN PREGNANCY",763,0,"CMV IN PREGNANCY"],
    [1500,3,"FETAL ANEMIA",770,0,"FETAL ANEMIA"],
    [1501,3,"FETAL ARRYTHMIA",782,0,"FETAL ARRYTHMIA"],
    [1502,3,"FETAL CARDIAC LESIONS",790,0,"FETAL CARDIAC LESIONS"],
    [1503,3,"THORACIC LESION",801,0,"THORACIC LESION"],
    [1504,3,"NEURAL TUBE DEFECT",810,0,"NEURAL TUBE DEFECT"],
    [1505,3,"ABDOMINAL LESION",815,0,"ABDOMINAL LESION"],
    [1506,3,"GENITO-URINARY LESIONS",824,0,"GENITO-URINARY LESIONS"],
    [1507,3,"FETAL THERAPY",832,0,"FETAL THERAPY"],
	[1508,3,"FETAL TUMORS",877,0,"FETAL TUMORS"],
	[1509, 1, "PELVIC", 1496, 1],
	[1510,6,"DOUBLE AORTIC ARCH",1192,0,"HEART AORTIC ARCH ANOMALY DOUBLE AORTIC ARCH"],
	[1511, 1, "PELVIC", 1496, 1],
	[1512, 5, "VSD", 1210, 0,"HEART VSD "],
	[1513, 5, "DOUBLE OUTLET RIGHT VENTRICLE", 1230, 0,"HEART DOUBLE OUTLET RIGHT VENTRICLE"],
	[1514, 5, "TETROLOGY OF FALLOT", 1496, 0,"HEART TETROLOGY OF FALLOT"],
	[1515, 5, "MALPOSITION", 1242, 0,"HEART MALPOSITION"],
	[1516, 5, "HETEROTAXY", 1247, 0,"HEART HETEROTAXY"],
	[1517, 5, "VENOUS ANOMALY", 1250, 0,"HEART VENOUS ANOMALY "],
	[1518,5,"MASS",1262,0,"HEART MASS"],
	[1519,5,"VALVULAR ANOMALY-HEART",1170,0,"HEART VALVULAR ANOMALY-HEART"],
	[1520,5,"AORTIC ARCH ANOMALY",1191,0,"HEART AORTIC ARCH ANOMALY"],
	[1521,5,"VERTEBRAL ANOMALY",1155,0,"MUSCULOSKELETAL VERTEBRAL ANOMALY"],
    [1518,2, " ", 1524, 1]
]